import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import Multiselect from "multiselect-react-dropdown";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Input,
  Label,
  Button,
  FormGroup,
  Badge,
  Spinner,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { DeleteAccount } from "../import/ApiEndPoint/ApiCalling";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";

// ✅ Our own CSS (clean, no SCSS needed)
import "../userForm.css";

// ✅ APIs (copy your originals into src/api to avoid CRA “outside src” error)
import {
  CreateAccountSave,
  CreateAccountUpdate,
  Get_RoleList,
  _BulkUpload,
  _Get,
  _GetList,
  _Post,
  _PostSave,
  _Put,
  AllCategoryList,
  _GetListData,
  ViewCompanyDetails,
  _GetByUrlOnly,
} from "../import/ApiEndPoint/ApiCalling";

import UserContext from "../import/context/Context";

import {
  Assign_Role_To_SuperAdmin,
  Bulk_Update_Product,
  Bulk_Update_User,
  // Bulk_Update_User,
  Bulk_Upload_User,
  // 👇 use the same endpoint as WareHouseList page
  Create_Warehouse_List,
  Image_URL,
  ListBranch,
  Role_list_by_Master,
  Rule_List,
  SubscriptinPlanList,
  Super_Admin_List,
  Update_Role_To_SuperAdmin,
  View_User_By_Id,
  Working_Hours_get,
  viewRawProductList,
  Deptartment_with_Role,
  All_Users_List,
  User_Assign_User,
  viewpincodedata,
  viewpincodedata1,
} from "../import/ApiEndPoint/Api";

const normalizeOpeningFinancialYear = (value) => {
  const raw = String(value || "").trim();

  const match = raw.match(/^(\d{4})\s*-\s*(\d{2}|\d{4})$/);
  if (!match) return raw;

  const startYear = match[1];
  const endYear = match[2].length === 4 ? match[2].slice(-2) : match[2];

  return `${startYear}-${endYear}`;
};

const getFYStartYear = (date = new Date()) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = d.getMonth();

  return m >= 3 ? y : y - 1;
};

const getCurrentOpeningFinancialYear = () => {
  const start = getFYStartYear(new Date());
  return normalizeOpeningFinancialYear(`${start}-${start + 1}`);
};

const buildOpeningFinancialYearOptions = (past = 5, future = 2) => {
  const currentStart = getFYStartYear(new Date());
  const arr = [];

  for (let y = currentStart - past; y <= currentStart + future; y++) {
    arr.push(normalizeOpeningFinancialYear(`${y}-${y + 1}`));
  }

  return arr.reverse();
};

const normalizeBulkKey = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const cleanBulkCell = (value) =>
  value === null || value === undefined ? "" : String(value).trim();

const cleanBulkDigits = (value) => cleanBulkCell(value).replace(/[^\d]/g, "");

const getBulkCell = (row, aliases = []) => {
  const normalized = {};

  Object.entries(row || {}).forEach(([key, value]) => {
    normalized[normalizeBulkKey(key)] = value;
  });

  for (const alias of aliases) {
    const key = normalizeBulkKey(alias);
    if (Object.prototype.hasOwnProperty.call(normalized, key)) {
      return normalized[key];
    }
  }

  return "";
};

const normalizeDateForInput = (value) => {
  if (value === null || value === undefined || value === "") return "";

  if (typeof value === "number" && Number.isFinite(value)) {
    // Excel serial date without loading the large XLSX package on page start.
    const excelEpoch = Date.UTC(1899, 11, 30);
    const parsedDate = new Date(excelEpoch + Math.floor(value) * 86400000);

    if (!Number.isNaN(parsedDate.getTime())) {
      return `${parsedDate.getUTCFullYear()}-${String(
        parsedDate.getUTCMonth() + 1,
      ).padStart(2, "0")}-${String(parsedDate.getUTCDate()).padStart(2, "0")}`;
    }
  }

  const raw = cleanBulkCell(value);
  const iso = raw.match(/^(\d{4})[-/]([01]?\d)[-/]([0-3]?\d)/);
  if (iso) {
    return `${iso[1]}-${String(iso[2]).padStart(2, "0")}-${String(
      iso[3],
    ).padStart(2, "0")}`;
  }

  const indian = raw.match(/^([0-3]?\d)[-/.]([01]?\d)[-/.](\d{2}|\d{4})$/);
  if (indian) {
    const year = indian[3].length === 2 ? `20${indian[3]}` : indian[3];
    return `${year}-${String(indian[2]).padStart(2, "0")}-${String(
      indian[1],
    ).padStart(2, "0")}`;
  }

  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0",
  )}-${String(date.getDate()).padStart(2, "0")}`;
};

const parseBulkService = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return [value];

  const raw = cleanBulkCell(value);
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed;
    if (parsed && typeof parsed === "object") return [parsed];
  } catch {}

  return raw
    .split(/[,;|]/)
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => (/^\d{6}$/.test(item) ? { pincode: item } : item));
};

const getEntityId = (value) => {
  if (!value) return "";
  if (typeof value === "object") {
    return String(
      value?._id ||
        value?.id ||
        value?.userId ||
        value?.roleId?._id ||
        value?.roleId ||
        "",
    );
  }
  return String(value);
};

const getUserRoleId = (user) =>
  getEntityId(user?.rolename?._id || user?.rolename || user?.roleId);

const getUserRoleName = (user) =>
  String(
    user?.rolename?.roleName || user?.rolename?.name || user?.position || "",
  ).trim();

const getUserDisplayName = (user) => {
  if (!user) return "";

  return (
    [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
    user?.fullName ||
    user?.name ||
    user?.email ||
    "Unnamed User"
  );
};

const getAssignedParentFromUser = (user, allUsers = []) => {
  const rawParent = user?.created_by;
  const parentId = getEntityId(rawParent);

  if (!parentId) return null;

  if (rawParent && typeof rawParent === "object") {
    const fullUser = (allUsers || []).find(
      (item) => String(item?._id) === String(parentId),
    );

    return fullUser || rawParent;
  }

  return (
    (allUsers || []).find((item) => String(item?._id) === String(parentId)) ||
    null
  );
};

const hydrateRolePricingRows = (
  roleRows = [],
  processList = [],
  products = [],
) => {
  const rows = Array.isArray(roleRows) ? roleRows : [];

  return rows.map((roleItem) => {
    const processName = roleItem?.process || "";
    const selectedStepName = roleItem?.roleName || "";
    const processSteps =
      (processList || []).find((process) => process?.name === processName)
        ?.steps ||
      roleItem?.processSteps ||
      [];

    const selectedStepIndex = processSteps.findIndex(
      (step) => step?.step_Name === selectedStepName,
    );

    const roleProducts = (products || [])
      .filter((product) => {
        const subStep = product?.SubStep || "";
        const nextSubStep = product?.NextSubStep || "";

        if (!selectedStepName) return false;
        if (selectedStepIndex === 0) return subStep === selectedStepName;

        return subStep === selectedStepName || nextSubStep === selectedStepName;
      })
      .map((product) => ({
        Product_Title: product?.Product_Title,
        stockUnit: product?.stockUnit,
      }));

    return {
      ...roleItem,
      processSteps,
      roleProducts,
      productAndPrice:
        Array.isArray(roleItem?.productAndPrice) &&
        roleItem.productAndPrice.length
          ? roleItem.productAndPrice
          : [{ productName: "", price: "", stockUnit: "" }],
    };
  });
};

const USER_BULK_ALIASES = {
  firstName: ["firstName", "Full Name", "Name"],
  service: ["service", "serviceArea", "Service Area"],
  OpeningBalance: ["OpeningBalance", "Opening Balance"],
  Type: ["Type", "Balance Type", "O/P Balance Type"],
  email: ["email", "Email"],
  Aadhar_No: ["Aadhar_No", "Aadhar No", "Aadhaar Number"],
  Pan_No: ["Pan_No", "PAN No", "PAN Number", "panNo"],
  State: ["State", "state"],
  City: ["City", "city"],
  pincode: ["pincode", "Pin Code", "PIN"],
  Father_name: ["Father_name", "Father Name"],
  Father_MobileNo: ["Father_MobileNo", "Father Mobile Number"],
  MotherMobileNo: ["MotherMobileNo", "Mother Mobile Number"],
  address1: ["address1", "Address"],
  last_job_Salary: ["last_job_Salary", "Salary", "Base Salary"],
  pfPercentage: ["pfPercentage", "PF Percentage"],
  DOB: ["DOB", "Date of Birth"],
  mobileNumber: ["mobileNumber", "Mobile Number", "Mobile"],
  DL_Num: ["DL_Num", "DL Number", "Driving License Number"],
  Account_Name: ["Account_Name", "Bank Name", "Account Name"],
  Account_No: ["Account_No", "Account Number"],
  Ifsc_code: ["Ifsc_code", "IFSC", "IFSC Code"],
  Country: ["Country", "country"],
  last_job_AppoitmentDate: ["last_job_AppoitmentDate", "Appointment Date"],
  panNo: ["panNo"],
};

const ROLE_PRICING_NAMES = [
  "Labour",
  "Production Manager",
  "Operator",
  "Packing And Labour",
  "Production Incharge",
  "WareHouse Incharge",
];

const readBulkFile = (file, mode) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = reject;

    if (mode === "text") reader.readAsText(file);
    else reader.readAsArrayBuffer(file);
  });

const readUserBulkRows = async (file) => {
  // XLSX is intentionally lazy-loaded. The old page loaded the whole library
  // even when the user never used Bulk Upload, increasing initial JS work.
  const XLSXModule = await import("xlsx");
  const XLSX = XLSXModule.default || XLSXModule;

  const fileName = String(file?.name || "").toLowerCase();
  const isCsv = fileName.endsWith(".csv");
  const fileData = await readBulkFile(file, isCsv ? "text" : "array");

  const workbook = XLSX.read(fileData, {
    type: isCsv ? "string" : "array",
    raw: false,
    cellDates: false,
  });

  const sheetName = workbook.SheetNames?.[0];
  if (!sheetName) return [];

  return XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
    defval: "",
    raw: false,
  });
};

const isEmptyUserBulkRow = (row) =>
  !Object.values(row || {}).some((value) => cleanBulkCell(value) !== "");

const normalizeExcelUserRow = (row, index, baseForm = {}) => {
  const service = parseBulkService(getBulkCell(row, USER_BULK_ALIASES.service));
  const panNo = cleanBulkCell(
    getBulkCell(row, USER_BULK_ALIASES.Pan_No),
  ).toUpperCase();

  return {
    ...baseForm,
    firstName: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.firstName),
    ).toUpperCase(),
    service,
    serviceArea: service,
    OpeningBalance: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.OpeningBalance),
    ),
    Type: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.Type)),
    email: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.email)),
    Aadhar_No: cleanBulkDigits(
      getBulkCell(row, USER_BULK_ALIASES.Aadhar_No),
    ).slice(0, 12),
    Pan_No: panNo,
    State: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.State)),
    City: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.City)),
    pincode: cleanBulkDigits(getBulkCell(row, USER_BULK_ALIASES.pincode)).slice(
      0,
      6,
    ),
    Father_name: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.Father_name)),
    Father_MobileNo: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.Father_MobileNo),
    ),
    MotherMobileNo: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.MotherMobileNo),
    ),
    address1: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.address1)),
    last_job_Salary: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.last_job_Salary),
    ),
    pfPercentage: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.pfPercentage),
    ),
    DOB: normalizeDateForInput(getBulkCell(row, USER_BULK_ALIASES.DOB)),
    mobileNumber: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.mobileNumber),
    ),
    DL_Num: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.DL_Num)),
    Account_Name: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.Account_Name),
    ),
    Account_No: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.Account_No)),
    Ifsc_code: cleanBulkCell(
      getBulkCell(row, USER_BULK_ALIASES.Ifsc_code),
    ).toUpperCase(),
    Country:
      cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.Country)) || "India",
    last_job_AppoitmentDate: normalizeDateForInput(
      getBulkCell(row, USER_BULK_ALIASES.last_job_AppoitmentDate),
    ),
    panNo: cleanBulkCell(getBulkCell(row, USER_BULK_ALIASES.panNo)),
    status: baseForm?.status || "Active",
    openingFinancialYear:
      baseForm?.openingFinancialYear || getCurrentOpeningFinancialYear(),
    _bulkRowNo: index + 1,
  };
};

const CreateAccount = () => {
  const [WareHouseList, setWareHouseList] = useState([]);
  const [SelectedWareHouse, setSelectedWareHouse] = useState([]);
  const [Rule, setRule] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [Branch, setBranch] = useState([]);
  const [BulkImport, setBulkImport] = useState(null);
  const [bulkUsers, setBulkUsers] = useState([]);
  const [expandedBulkIndex, setExpandedBulkIndex] = useState(null);
  const [activeBulkIndex, setActiveBulkIndex] = useState(-1);
  const [bulkSavingIndex, setBulkSavingIndex] = useState(null);
  const [bulkSaveAllLoading, setBulkSaveAllLoading] = useState(false);
  const [Master, setMaster] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [DepartmentWithRole, setDepartmentWithRole] = useState([]);
  const [SelectedDepartment, setSelectedDepartment] = useState([]);
  const [SelectedDepartments, setSelectedDepartments] = useState([]);
  const [ShowParentList, setShowParentList] = useState([]);
  const [tableDataList, setTableDataList] = useState([]);
  const [GetParentList, setGetParentList] = useState([]);
  const [ShowChildUnlink, setShowChildUnlink] = useState([]);
  const [ALLheadsofDept, setALLheadsofDept] = useState([]);
  const [ShowChildList, setShowChildList] = useState([]);
  const [GetChildList, setGetChildList] = useState([]);
  const [Show, setShow] = useState(false);
  const [Child, setChild] = useState(false);
  const [names, setNames] = useState("");
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [SelectedParentForHeirarchy, setSelectedParentForHeirarchy] = useState(
    {},
  );
  const [SelectedChildForHeirarchy, setSelectedChildForHeirarchy] = useState(
    [],
  );
  const [NoChild, setNoChild] = useState(false);

  const [Party, setParty] = useState(false);
  const [HeadOfDepartment, setHeadOfDepartment] = useState(false);
  const [Parent, setParent] = useState("");
  const [ParentName, setParentName] = useState("");
  const [SelectedRoleId, setSelectedRoleId] = useState("");
  const [ChildList, setChildList] = useState([]);
  const [AllUsersList, setAllUsersList] = useState([]);
  const [assignedTo, setAssignedTo] = useState(null);
  const [account, setAccount] = useState("");
  const [loadedEditUser, setLoadedEditUser] = useState(null);
  const [currentAssignedParent, setCurrentAssignedParent] = useState(null);
  const assignmentHydratedRef = useRef("");

  const openingFYOptions = buildOpeningFinancialYearOptions(5, 2);

  const [formData, setFormData] = useState({
    openingFinancialYear: getCurrentOpeningFinancialYear(),
    role: [
      {
        process: "",
        roleName: "",
        productAndPrice: [
          {
            productName: "",
            price: "",
            stockUnit: "",
          },
        ],
      },
    ],
  });

  const [Image, setImage] = useState(null);
  const [dropdownValue, setdropdownValue] = useState([]);
  const [SelectedRules, SetRules] = useState([]);
  const [AllAssignRoleList, setAllAssignRoleList] = useState([]);
  const [SubsCriptionList, setSubsCriptionList] = useState([]);
  const [SelectedRoleToAssign, setSelectedRoleToAssign] = useState([]);
  const [Mode, setMode] = useState("");

  const [WareHouseIncharge, setWareHouseIncharge] = useState(false);
  const [BulkUpload, setBulkUpload] = useState(false);
  const [references, setReferences] = useState([
    { id: Date.now(), name: "", relation: "", mobile: "" },
  ]);

  const [productName, setProductName] = useState([]);
  const [rowCount, setRowCount] = useState(1);
  const [list, setList] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [filters, setFilters] = useState({ state: "", district: "" });

  // ✅ NEW (from previous code): pincode -> if multiple matches, show city dropdown
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCityValue, setSelectedCityValue] = useState("");

  // ✅ NEW (from previous code): useful for "SuperAdmin" parent role in hierarchy

  // const [locationData, setLocationData] = useState([]); // you already have this
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 100; // fixed page size
  const [pinLoading, setPinLoading] = useState(false);
  const [pinSearch, setPinSearch] = useState(""); // keep last search string for Next/Prev

  // Performance guards: heavy lists are loaded only when their feature is used.
  const pinSearchTimerRef = useRef(null);
  const pincodeListRequestedRef = useRef(false);
  const pricingDataRequestedRef = useRef(false);
  const warehouseDataRequestedRef = useRef(false);
  const allUsersRequestRef = useRef(null);

  useEffect(() => {
    const id = "create-user-inline-css";
    if (document.getElementById(id)) return;
    const s = document.createElement("style");
    s.id = id;
    s.textContent = `
    .cu *{ font-size:16px !important; }
    .cu h1,.cu h2{ font-size:20px !Important; }
    .cu label{ font-size:12px !important; }
    .cu input, .cu select, .cu textarea, .cu .myphoneinput {
      font-size:12px !important; height:34px;
    }
    .cu button{ font-size:12px !important; padding:6px 12px; }
    .cu .table th, .cu .table td { font-size:12px !important; }
    .cu-bulk-card{
      background:#fff;
      border:1px solid #e5e7eb;
      border-radius:10px;
      padding:12px 14px;
      margin-bottom:10px;
      box-shadow:0 2px 8px rgba(0,0,0,.08);
    }
    .cu-bulk-head{
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:12px;
      cursor:pointer;
    }
    .cu-bulk-title{ font-weight:700; font-size:14px !important; }
    .cu-bulk-cross{
      border:none;
      background:transparent;
      font-size:22px !important;
      line-height:1;
      cursor:pointer;
      padding:0 4px !important;
    }
    .cu-bulk-body{
      margin-top:12px;
      padding-top:12px;
      border-top:1px solid #e5e7eb;
    }
    .cu-bulk-error{ font-size:12px !important; margin-top:6px; color:#b91c1c; }
  `;
    document.head.appendChild(s);
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    const next = { ...filters, [name]: value };
    setFilters(next);

    const search = `${next.state} ${next.district}`.trim();
    setPinSearch(search);

    // Do not hit the pincode API on every keystroke.
    if (pinSearchTimerRef.current) {
      clearTimeout(pinSearchTimerRef.current);
    }

    pinSearchTimerRef.current = setTimeout(() => {
      fetchPincodeData(1, limit, search);
    }, 350);
  };

  const filteredList = locationData || [];

  const handleSelectFiltered = () => {
    filteredList.forEach((item) => handleCheckboxChange(item));
  };

  const toggle = () => {
    const opening = !modal;
    setModal(opening);

    // The pincode dataset can be very large. Load the first page only when
    // the service-area modal is actually opened.
    if (
      opening &&
      !pincodeListRequestedRef.current &&
      !pinLoading &&
      !locationData.length
    ) {
      pincodeListRequestedRef.current = true;
      fetchPincodeData(1, limit, pinSearch);
    }
  };
  const Context = useContext(UserContext);
  const navigate = useNavigate();
  const Params = useParams(); // expects { id } in route like /app/users/create/:id

  const goBack = () => navigate(-1); // ✅ FIX: navigate(-1)() was crashing; keeping UX same

  const makeEmptyReference = () => ({
    id: Date.now() + Math.random(),
    name: "",
    relation: "",
    mobile: "",
  });

  const getBulkBaseForm = () => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const role =
      Array.isArray(formData?.role) && formData.role.length
        ? JSON.parse(JSON.stringify(formData.role))
        : [
            {
              process: "",
              roleName: "",
              productAndPrice: [{ productName: "", price: "", stockUnit: "" }],
            },
          ];

    return {
      database: formData?.database || userData?.database || "",
      created_by: formData?.created_by || userData?._id || "",
      rolename: formData?.rolename || "",
      position: formData?.position || "",
      shift: formData?.shift || "",
      branch: formData?.branch || "",
      status: formData?.status || "Active",
      openingFinancialYear: normalizeOpeningFinancialYear(
        formData?.openingFinancialYear || getCurrentOpeningFinancialYear(),
      ),
      role,
    };
  };

  const getCurrentBulkSnapshot = (item = {}) => ({
    ...item,
    data: {
      ...formData,
      service:
        Array.isArray(selectedItems) && selectedItems.length
          ? selectedItems
          : formData?.service || [],
      serviceArea:
        Array.isArray(selectedItems) && selectedItems.length
          ? selectedItems
          : formData?.serviceArea || [],
    },
    references: Array.isArray(references)
      ? references.map((ref) => ({ ...ref }))
      : [makeEmptyReference()],
    selectedRules: Array.isArray(SelectedRules) ? [...SelectedRules] : [],
    selectedWareHouse: Array.isArray(SelectedWareHouse)
      ? [...SelectedWareHouse]
      : [],
    selectedItems: Array.isArray(selectedItems) ? [...selectedItems] : [],
    assignedTo: assignedTo || null,
    image: Image || null,
    wareHouseIncharge: !!WareHouseIncharge,
    selectedRoleToAssign: Array.isArray(SelectedRoleToAssign)
      ? [...SelectedRoleToAssign]
      : [],
  });

  const loadBulkUserIntoEditor = (item, index) => {
    if (!item) return;

    const data = item?.data || getBulkBaseForm();
    setActiveBulkIndex(index);
    setFormData(data);
    setReferences(
      Array.isArray(item?.references) && item.references.length
        ? item.references.map((ref) => ({ ...ref }))
        : [makeEmptyReference()],
    );
    SetRules(Array.isArray(item?.selectedRules) ? item.selectedRules : []);
    setSelectedWareHouse(
      Array.isArray(item?.selectedWareHouse) ? item.selectedWareHouse : [],
    );
    setSelectedItems(
      Array.isArray(item?.selectedItems)
        ? item.selectedItems
        : Array.isArray(data?.serviceArea)
          ? data.serviceArea
          : [],
    );
    setAssignedTo(item?.assignedTo || null);
    setImage(item?.image || null);
    setWareHouseIncharge(!!item?.wareHouseIncharge);
    setSelectedRoleToAssign(
      Array.isArray(item?.selectedRoleToAssign)
        ? item.selectedRoleToAssign
        : [],
    );
    setRowCount(
      Array.isArray(data?.role) && data.role.length ? data.role.length : 1,
    );
    setShowCityDropdown(false);
    setCityOptions([]);
    setSelectedCityValue("");
    setSelectedDepartments("");
    setSelectedDepartment([]);
    setShowParentList([]);
    setTableDataList([]);
    setParent("");
    setNames("");
  };

  const resetBulkEditor = () => {
    const base = getBulkBaseForm();
    setFormData(base);
    setReferences([makeEmptyReference()]);
    SetRules([]);
    setSelectedWareHouse([]);
    setSelectedItems([]);
    setAssignedTo(null);
    setImage(null);
    setWareHouseIncharge(false);
    setSelectedRoleToAssign([]);
    setRowCount(1);
    setShowCityDropdown(false);
    setCityOptions([]);
    setSelectedCityValue("");
  };

  const exitBulkUploadMode = () => {
    setBulkUpload(false);
    setBulkImport(null);
    setBulkUsers([]);
    setExpandedBulkIndex(null);
    setActiveBulkIndex(-1);
    setBulkSavingIndex(null);
    setBulkSaveAllLoading(false);
    resetBulkEditor();
  };

  const handleBulkFileChange = async (event) => {
    const file = event?.target?.files?.[0] || null;
    setBulkImport(file);
    if (!file) return;

    try {
      setLoading(true);
      const rows = await readUserBulkRows(file);
      const validRows = rows.filter((row) => !isEmptyUserBulkRow(row));

      if (!validRows.length) {
        swal("Error", "No valid user rows found in the selected file", "error");
        return;
      }

      const baseForm = getBulkBaseForm();
      const normalizedRows = validRows.map((row, index) =>
        normalizeExcelUserRow(row, index, baseForm),
      );

      if (normalizedRows.length === 1) {
        const data = normalizedRows[0];
        setFormData(data);
        setReferences([makeEmptyReference()]);
        setSelectedItems(
          Array.isArray(data?.serviceArea) ? data.serviceArea : [],
        );
        setRowCount(
          Array.isArray(data?.role) && data.role.length ? data.role.length : 1,
        );
        setBulkUsers([]);
        setExpandedBulkIndex(null);
        setActiveBulkIndex(-1);
        setBulkUpload(false);
        swal(
          "File loaded",
          "The user data has been filled in the form.",
          "success",
        );
        return;
      }

      const prepared = normalizedRows.map((data, index) => ({
        tempId: `${Date.now()}-${index}`,
        errorMessage: "",
        data,
        references: [makeEmptyReference()],
        selectedRules: Array.isArray(SelectedRules) ? [...SelectedRules] : [],
        selectedWareHouse: Array.isArray(SelectedWareHouse)
          ? [...SelectedWareHouse]
          : [],
        selectedItems: Array.isArray(data?.serviceArea)
          ? [...data.serviceArea]
          : [],
        assignedTo: assignedTo || null,
        image: null,
        wareHouseIncharge: !!WareHouseIncharge,
        selectedRoleToAssign: Array.isArray(SelectedRoleToAssign)
          ? [...SelectedRoleToAssign]
          : [],
      }));

      setBulkUsers(prepared);
      setExpandedBulkIndex(0);
      loadBulkUserIntoEditor(prepared[0], 0);
      swal(
        "File loaded",
        `${prepared.length} user rows added. Open each row to review or edit it.`,
        "success",
      );
    } catch (err) {
      console.log("[CreateAccount] bulk file read failed:", err);
      swal(
        "Error",
        "Could not read this file. Please upload a valid .xlsx, .xls or .csv file.",
        "error",
      );
    } finally {
      setLoading(false);
      if (event?.target) event.target.value = "";
    }
  };

  const openBulkUser = (index) => {
    const synced = bulkUsers.map((item, itemIndex) =>
      itemIndex === activeBulkIndex ? getCurrentBulkSnapshot(item) : item,
    );
    setBulkUsers(synced);

    if (expandedBulkIndex === index) {
      setExpandedBulkIndex(null);
      return;
    }

    setExpandedBulkIndex(index);
    loadBulkUserIntoEditor(synced[index], index);
  };

  const removeBulkUser = (index, event) => {
    if (event) event.stopPropagation();

    const synced = bulkUsers.map((item, itemIndex) =>
      itemIndex === activeBulkIndex ? getCurrentBulkSnapshot(item) : item,
    );
    const next = synced.filter((_, itemIndex) => itemIndex !== index);
    setBulkUsers(next);

    if (!next.length) {
      setExpandedBulkIndex(null);
      setActiveBulkIndex(-1);
      resetBulkEditor();
      return;
    }

    const nextIndex = Math.min(index, next.length - 1);
    setExpandedBulkIndex(nextIndex);
    loadBulkUserIntoEditor(next[nextIndex], nextIndex);
  };

  const clearSavedBulkUser = (index) => {
    const next = bulkUsers.filter((_, itemIndex) => itemIndex !== index);
    setBulkUsers(next);

    if (!next.length) {
      setExpandedBulkIndex(null);
      setActiveBulkIndex(-1);
      resetBulkEditor();
      return;
    }

    const nextIndex = Math.min(index, next.length - 1);
    setExpandedBulkIndex(nextIndex);
    loadBulkUserIntoEditor(next[nextIndex], nextIndex);
  };

  useEffect(() => {
    if (!BulkUpload || activeBulkIndex < 0 || !bulkUsers.length) return;

    setBulkUsers((previous) =>
      previous.map((item, itemIndex) =>
        itemIndex === activeBulkIndex ? getCurrentBulkSnapshot(item) : item,
      ),
    );
    // The active row is intentionally synchronized whenever its editable state changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formData,
    references,
    SelectedRules,
    SelectedWareHouse,
    selectedItems,
    assignedTo,
    Image,
    WareHouseIncharge,
    SelectedRoleToAssign,
    BulkUpload,
    activeBulkIndex,
  ]);

  // ✅ normalize Rule objects for Multiselect display without changing backend objects
  const ruleOptions = useMemo(
    () =>
      (Rule || []).map((r) => ({
        ...r,
        ruleName:
          r?.ruleName || r?.name || r?.Rule_Name || r?.title || "Unnamed Rule",
      })),
    [Rule],
  );

  const selectedRuleValues = useMemo(
    () =>
      (SelectedRules || []).map((r) => ({
        ...r,
        ruleName:
          r?.ruleName || r?.name || r?.Rule_Name || r?.title || "Unnamed Rule",
      })),
    [SelectedRules],
  );

  // ---------------------- data loaders ----------------------
  const isChecked = (item) =>
    selectedItems.some((i) => String(i.pincode) === String(item.pincode));

  const handleCheckboxChange = (item) => {
    const exists = selectedItems.some(
      (i) => String(i.pincode) === String(item.pincode),
    );
    if (exists) {
      setSelectedItems((prev) =>
        prev.filter((i) => String(i.pincode) !== String(item.pincode)),
      );
    } else {
      setSelectedItems((prev) => [...prev, item]);
    }
  };

  // ✅ NEW (from previous code): pincode lookup by 6-digit with multi-city support
  const applyPincodeRowToForm = (row, pincodeVal) => {
    const city = row?.city || row?.City || row?.District || "";
    const district = row?.district || row?.District || "";
    const state = row?.state || row?.StateName || row?.State || "";
    const country = row?.country || row?.Country || "India";

    setFormData((p) => ({
      ...p,
      pincode: pincodeVal,
      City: city,
      District: district,
      State: state,
      Country: country,
    }));
  };

  const fetchPincodeData = async (page = 1, limit = 10, search = "") => {
    const query = `?page=${page}&limit=${limit}&search=${encodeURIComponent(search || "")}`;
    setPinLoading(true);

    try {
      const res = await _GetByUrlOnly(viewpincodedata + query);

      const list = res?.pinCodeList || [];
      setLocationData(list);
      setPage(res?.currentPage || page);
      setTotalPages(res?.totalPages || 1);

      pincodeListRequestedRef.current = true;
    } catch (err) {
      console.error("[CreateAccount] pincode list load failed:", err);
      pincodeListRequestedRef.current = false;
    } finally {
      setPinLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (pinSearchTimerRef.current) {
        clearTimeout(pinSearchTimerRef.current);
      }
    };
  }, []);

  const fetchPincodeByValue = async (pincodeVal) => {
    try {
      const pin = String(pincodeVal || "").trim();

      if (!/^\d{6}$/.test(pin)) {
        setShowCityDropdown(false);
        setCityOptions([]);
        setSelectedCityValue("");
        return;
      }

      // ✅ viewpincodedata1 takes ?pincode= in query
      const joiner = String(viewpincodedata1).includes("?") ? "&" : "?";
      const res = await _GetByUrlOnly(
        `${viewpincodedata1}${joiner}pincode=${pin}`,
      );

      // ✅ response: { status, pinCodes: [...] }
      const pinCodes = res?.pinCodes || [];

      const options = (pinCodes || []).map((x) => ({
        state: x?.state || "",
        district: x?.district || "",
        city: x?.city || "",
        pincode: x?.pincode || pin,
        _id: x?._id,
        _raw: x,
      }));

      if (options.length === 1) {
        setShowCityDropdown(false);
        setCityOptions([]);
        setSelectedCityValue("");
        applyPincodeRowToForm(options[0], pin);
        return;
      }

      if (options.length > 1) {
        // ✅ 3) SET CITY DROPDOWN VALUES FROM API RESPONSE
        setCityOptions(options);
        setShowCityDropdown(true);
        setSelectedCityValue("");

        // clear until user picks a city
        setFormData((p) => ({
          ...p,
          pincode: pin,
          City: "",
          District: "",
          State: "",
          Country: "India",
        }));
        return;
      }

      // no data found
      setShowCityDropdown(false);
      setCityOptions([]);
      setSelectedCityValue("");
      setFormData((p) => ({
        ...p,
        pincode: pin,
        City: "",
        District: "",
        State: "",
        Country: "",
      }));
    } catch {
      // safe fail
    }
  };

  // ✅ NEW (from previous code): a reusable handler for Pin Code input
  const handlePincodeChange = async (e) => {
    const val = e?.target?.value;
    setFormData((p) => ({ ...p, pincode: val }));
    const pin = String(val || "").trim();

    if (/^\d{6}$/.test(pin)) {
      await fetchPincodeByValue(pin);
    } else {
      setShowCityDropdown(false);
      setCityOptions([]);
      setSelectedCityValue("");
      setFormData((p) => ({
        ...p,
        City: p?.City || "",
        State: p?.State || "",
        Country: p?.Country || "",
      }));
    }
  };

  // ✅ NEW (from previous code): when city dropdown selection happens
  const handleCitySelectForPincode = (cityObjOrValue) => {
    let picked =
      typeof cityObjOrValue === "string"
        ? (cityOptions || []).find((x) => x.city === cityObjOrValue)
        : cityObjOrValue;

    if (!picked) return;

    setSelectedCityValue(picked.city || "");
    applyPincodeRowToForm(picked, picked.pincode || formData?.pincode);
    setShowCityDropdown(false);
  };

  const fetchRawProduct = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const res = await _GetListData(viewRawProductList, userData?.database);
      setProductName(res?.Product || []);
    } catch (e) {}
  };

  const UserList = async (force = false) => {
    if (!force && Array.isArray(AllUsersList) && AllUsersList.length) {
      return AllUsersList;
    }

    if (!force && allUsersRequestRef.current) {
      return allUsersRequestRef.current;
    }

    const request = (async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        const response = await _Get(All_Users_List, userData?.database);
        const users = Array.isArray(response?.User) ? response.User : [];
        setAllUsersList(users);
        return users;
      } catch {
        return [];
      } finally {
        allUsersRequestRef.current = null;
      }
    })();

    allUsersRequestRef.current = request;
    return request;
  };

  useEffect(() => {
    // Department data is needed for the first hierarchy dropdown.
    // The much larger All Users list is loaded later, only when hierarchy
    // details are actually needed.
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (!userData?.database) return;

    const timer = setTimeout(() => {
      _Get(Deptartment_with_Role, userData.database)
        .then((res) => setDepartmentWithRole(res?.Department || []))
        .catch(() => {});
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  const handleDropList = (event) => {
    const selectedId = event.target.value || "";
    const selectedUser =
      (tableDataList || []).find(
        (user) => String(user?._id) === String(selectedId),
      ) || null;

    setAssignedTo(selectedId || null);
    setShowParentList(selectedUser ? [selectedUser] : []);
    setCurrentAssignedParent(selectedUser);
    setNames(selectedId);
  };

  const handleAssignMemberSubmit = async () => {
    if (!assignedTo) {
      swal(
        "Select Parent",
        "Please select the member this user reports to.",
        "warning",
      );
      return;
    }

    try {
      const payload = {
        parentId: assignedTo,
        childs: [{ id: Params?.id }],
      };

      await _PostSave(User_Assign_User, payload);

      let selectedParent =
        (AllUsersList || []).find(
          (user) => String(user?._id) === String(assignedTo),
        ) || null;

      const refreshedUsers = await UserList(true);

      selectedParent =
        refreshedUsers.find(
          (user) => String(user?._id) === String(assignedTo),
        ) || selectedParent;

      setCurrentAssignedParent(selectedParent);
      setShowParentList(selectedParent ? [selectedParent] : []);
      setNames(assignedTo);
      setLoadedEditUser((previous) =>
        previous
          ? {
              ...previous,
              created_by: selectedParent || assignedTo,
            }
          : previous,
      );
      assignmentHydratedRef.current = "";
      swal("Assigned Successfully");
    } catch (err) {
      swal("Something Went Wrong");
    }
  };

  const handleReferenceInputChange = (id, field, value) => {
    setReferences((prev) =>
      prev.map((ref) => (ref.id === id ? { ...ref, [field]: value } : ref)),
    );
  };

  const fetchList = async () => {
    try {
      const data = JSON.parse(localStorage.getItem("userData"));
      const res = await AllCategoryList(data?.id, data?.database);
      setList(res?.Category || []);
    } catch {}
  };

  const addReference = () => {
    setReferences((prev) => [
      ...prev,
      { id: Date.now(), name: "", relation: "", mobile: "" },
    ]);
  };

  const removeReference = (id) => {
    setReferences((prev) => prev.filter((ref) => ref.id !== id));
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData?.database) {
      setFormData((p) => ({ ...p, database: userData?.database }));
    }
  }, []);

  // ✅ Keep warehouse multiselect selection stable in Update mode
  useEffect(() => {
    if (!Array.isArray(SelectedWareHouse) || SelectedWareHouse.length === 0)
      return;
    if (!Array.isArray(WareHouseList) || WareHouseList.length === 0) return;

    const mapped = SelectedWareHouse.map((warehouse) => {
      const warehouseId = getEntityId(
        warehouse?._id ||
          warehouse?.id ||
          warehouse?.warehouseId ||
          warehouse?.warehouse?._id ||
          warehouse,
      );

      const option = (WareHouseList || []).find(
        (item) => String(item?._id) === String(warehouseId),
      );

      return option || warehouse;
    }).filter(Boolean);

    const oldIds = SelectedWareHouse.map((item) =>
      getEntityId(item?._id || item?.id || item),
    ).join(",");

    const newIds = mapped
      .map((item) => getEntityId(item?._id || item?.id || item))
      .join(",");

    const oldNames = SelectedWareHouse.map(
      (item) => item?.warehouseName || "",
    ).join(",");

    const newNames = mapped.map((item) => item?.warehouseName || "").join(",");

    if (oldIds !== newIds || oldNames !== newNames) {
      setSelectedWareHouse(mapped);
    }
  }, [WareHouseList, SelectedWareHouse]);

  // ✅ Map saved rule IDs/partial objects back to complete rule options
  useEffect(() => {
    if (!Array.isArray(SelectedRules) || !SelectedRules.length) return;
    if (!Array.isArray(Rule) || !Rule.length) return;

    const mapped = SelectedRules.map((selectedRule) => {
      const selectedId = getEntityId(selectedRule);
      return (
        Rule.find((rule) => String(rule?._id) === String(selectedId)) ||
        selectedRule
      );
    });

    const changed = mapped.some(
      (item, index) =>
        (item?.ruleName || item?.name || "") !==
        (SelectedRules[index]?.ruleName || SelectedRules[index]?.name || ""),
    );

    if (changed) SetRules(mapped);
  }, [Rule, SelectedRules]);

  // ====== Edit-mode loader: fills personal, official and role-specific data ======
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    assignmentHydratedRef.current = "";
    setLoadedEditUser(null);
    setCurrentAssignedParent(null);

    if (user?.rolename?.roleName === "MASTER") {
      _GetList(SubscriptinPlanList, user?.database)
        .then((res) => setSubsCriptionList(res?.Subscription || []))
        .catch(() => {});
    }

    if (String(Params?.id) === "0") {
      setMode("Create");

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setFormData((previous) => ({
              ...previous,
              geotagging: `${position.coords.latitude},${position.coords.longitude}`,
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            }));
          },
          () => {},
          { timeout: 10000, enableHighAccuracy: true },
        );
      }
    } else {
      setMode("Update");

      (async () => {
        try {
          let response;

          try {
            response = await _GetByUrlOnly(
              `${String(View_User_By_Id).replace(/\/+$/, "")}/${Params?.id}`,
            );
          } catch {
            try {
              response = await _Get(View_User_By_Id, Params?.id);
            } catch {}
          }

          let userDataFromApi =
            response?.User ||
            response?.user ||
            response?.data?.User ||
            response?.data?.user ||
            response?.data ||
            response;

          if (Array.isArray(userDataFromApi)) {
            userDataFromApi = userDataFromApi[0] || null;
          }

          if (!userDataFromApi || typeof userDataFromApi !== "object") {
            throw new Error("User not found in response");
          }

          const savedRoleObject =
            userDataFromApi?.rolename &&
            typeof userDataFromApi.rolename === "object"
              ? userDataFromApi.rolename
              : null;

          const savedRoleName =
            savedRoleObject?.roleName ||
            savedRoleObject?.name ||
            userDataFromApi?.position ||
            "";

          const savedService = parseBulkService(
            Array.isArray(userDataFromApi?.serviceArea) &&
              userDataFromApi.serviceArea.length
              ? userDataFromApi.serviceArea
              : userDataFromApi?.service,
          );

          const savedRolePricing = hydrateRolePricingRows(
            Array.isArray(userDataFromApi?.role) ? userDataFromApi.role : [],
            list,
            productName,
          );

          const normalized = {
            ...userDataFromApi,
            openingFinancialYear: normalizeOpeningFinancialYear(
              userDataFromApi?.openingFinancialYear ||
                getCurrentOpeningFinancialYear(),
            ),
            password: "",
            DOB: normalizeDateForInput(userDataFromApi?.DOB),
            last_job_AppoitmentDate: normalizeDateForInput(
              userDataFromApi?.last_job_AppoitmentDate,
            ),
            branch: getEntityId(userDataFromApi?.branch),
            shift: getEntityId(userDataFromApi?.shift),
            rolename: getEntityId(userDataFromApi?.rolename),
            position: savedRoleName,
            service: savedService,
            serviceArea: savedService,
            role: savedRolePricing.length
              ? savedRolePricing
              : userDataFromApi?.role || [],
          };

          if (!normalized.imageuri && normalized.profileImage) {
            normalized.imageuri = `${String(Image_URL).replace(/\/+$/, "")}/${
              normalized.profileImage
            }`;
          }

          setLoadedEditUser(userDataFromApi);

          // On edit we need the large users list only when this user already
          // participates in the hierarchy. Create mode does not fetch it.
          if (getEntityId(userDataFromApi?.created_by)) {
            UserList();
          }

          SetRules(
            Array.isArray(userDataFromApi?.setRule)
              ? userDataFromApi.setRule
              : [],
          );

          setSelectedItems(savedService);
          setRowCount(
            Array.isArray(normalized?.role) && normalized.role.length
              ? normalized.role.length
              : 1,
          );

          const isWarehouseRole = savedRoleName === "WareHouse Incharge";

          const savedWarehouses = Array.isArray(userDataFromApi?.warehouse)
            ? userDataFromApi.warehouse
                .map((warehouse) => warehouse || null)
                .filter(Boolean)
            : [];

          setWareHouseIncharge(isWarehouseRole || savedWarehouses.length > 0);
          setSelectedWareHouse(savedWarehouses);

          if (
            userDataFromApi?.pincode &&
            /^\d{6}$/.test(String(userDataFromApi.pincode))
          ) {
            fetchPincodeByValue(String(userDataFromApi.pincode));
          }

          setFormData(normalized);

          setReferences(
            Array.isArray(userDataFromApi?.reference) &&
              userDataFromApi.reference.length > 0
              ? userDataFromApi.reference.map((reference, index) => ({
                  id: Date.now() + index,
                  name: reference?.name || "",
                  relation: reference?.relation || "",
                  mobile: reference?.mobile || "",
                }))
              : [makeEmptyReference()],
          );

          try {
            const roleResponse = await Get_RoleList(
              normalized?._id || Params?.id,
              normalized?.database || user?.database,
            );

            setSelectedRoleToAssign(
              Array.isArray(roleResponse?.Role) ? roleResponse.Role : [],
            );
          } catch {
            setSelectedRoleToAssign([]);
          }
        } catch (err) {
          console.log("[CreateAccount] load user failed:", err);
          swal("Couldn't load user details");
        }
      })();
    }

    (async () => {
      try {
        if (user?.rolename?.roleName === "MASTER") {
          setMaster(true);

          const response = await _Get(Role_list_by_Master, user?._id);
          const roles = response?.Role || [];
          const superAdminRoles = roles.filter((role) =>
            (role?.roleName || "").toLowerCase().includes("superadmin"),
          );
          const withoutMaster = roles.filter(
            (role) => role?.roleName !== "MASTER",
          );

          if (superAdminRoles.length) setdropdownValue(superAdminRoles);
          if (withoutMaster.length) setAllAssignRoleList(withoutMaster);
        } else {
          const response = await Get_RoleList(user?._id, user?.database);
          const availableRoles = (response?.Role || [])
            .filter((role) => role?.roleName !== "Customer")
            .filter((role) => role?.roleName !== "Transporter")
            .filter((role) => role?.roleName !== "SuperAdmin");

          setdropdownValue(availableRoles);
        }
      } catch {
        swal("Roles List Not found");
      }
    })();
  }, [Params?.id]);

  /*
    Rebuild process-step and product dropdown options after the supporting
    lists finish loading. Saved prices and selections remain unchanged.
  */
  useEffect(() => {
    if (String(Params?.id) === "0") return;
    if (!Array.isArray(formData?.role) || !formData.role.length) return;

    setFormData((previous) => {
      const hydratedRows = hydrateRolePricingRows(
        previous?.role || [],
        list,
        productName,
      );

      const before = JSON.stringify(previous?.role || []);
      const after = JSON.stringify(hydratedRows);

      if (before === after) return previous;

      return {
        ...previous,
        role: hydratedRows,
      };
    });
  }, [Params?.id, list, productName]);

  // Load process + product pricing data only for roles that use that section.
  useEffect(() => {
    const roleName =
      formData?.position ||
      dropdownValue.find(
        (role) => String(role?._id) === String(formData?.rolename),
      )?.roleName ||
      formData?.rolename?.roleName ||
      "";

    if (!ROLE_PRICING_NAMES.includes(roleName)) return;
    if (pricingDataRequestedRef.current) return;

    pricingDataRequestedRef.current = true;

    Promise.allSettled([fetchList(), fetchRawProduct()]).catch(() => {
      pricingDataRequestedRef.current = false;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.position, formData?.rolename, dropdownValue]);

  /*
    Restore the current hierarchy assignment using the same source used by
    AssignTeamMember: the child's created_by field points to its parent.
  */
  useEffect(() => {
    if (String(Params?.id) === "0") return;
    if (!loadedEditUser) return;
    if (!Array.isArray(AllUsersList) || !AllUsersList.length) return;

    const parentId = getEntityId(loadedEditUser?.created_by);
    const hydrationKey = `${Params?.id}:${parentId}:${
      DepartmentWithRole.length
    }:${AllUsersList.length}`;

    if (assignmentHydratedRef.current === hydrationKey) return;

    const assignedParent = getAssignedParentFromUser(
      loadedEditUser,
      AllUsersList,
    );

    setCurrentAssignedParent(assignedParent);
    setAssignedTo(parentId || null);
    setNames(parentId || "");

    if (!parentId || !assignedParent) {
      setSelectedDepartments("");
      setSelectedDepartment([]);
      setParent("");
      setShowParentList([]);
      setTableDataList([]);
      assignmentHydratedRef.current = hydrationKey;
      return;
    }

    const parentRoleId = getUserRoleId(assignedParent);

    const matchedDepartment = (DepartmentWithRole || []).find((department) =>
      (department?.roles || []).some(
        (role) =>
          String(role?.roleId?._id || role?.roleId) === String(parentRoleId),
      ),
    );

    if (!matchedDepartment) {
      setShowParentList([assignedParent]);
      setTableDataList([assignedParent]);
      assignmentHydratedRef.current = hydrationKey;
      return;
    }

    const departmentRoles = matchedDepartment?.roles || [];
    const matchedRole = departmentRoles.find(
      (role) =>
        String(role?.roleId?._id || role?.roleId) === String(parentRoleId),
    );

    const parentCandidates = (AllUsersList || []).filter(
      (user) => String(getUserRoleId(user)) === String(parentRoleId),
    );

    const candidatesWithCurrentParent = parentCandidates.some(
      (user) => String(user?._id) === String(parentId),
    )
      ? parentCandidates
      : [assignedParent, ...parentCandidates];

    setSelectedDepartments(matchedDepartment?._id || "");
    setSelectedDepartment(departmentRoles);
    setParent(matchedRole?._id || "");
    setParentName(matchedRole?.roleName || getUserRoleName(assignedParent));
    setSelectedRoleId(parentRoleId);
    setTableDataList(candidatesWithCurrentParent);
    setShowParentList([assignedParent]);
    setShow(true);
    assignmentHydratedRef.current = hydrationKey;
  }, [Params?.id, loadedEditUser, AllUsersList, DepartmentWithRole]);

  // Rules are secondary lookup data; defer until after the first paint.
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");
    if (!userInfo?.database) return;

    const timer = setTimeout(() => {
      _Get(Rule_List, userInfo.database)
        .then((res) => setRule(res?.Rule || []))
        .catch(() => {});
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  // Warehouse data is often large and is irrelevant for most users.
  // Fetch it only when the selected/saved role actually needs warehouses.
  useEffect(() => {
    const selectedRoleName =
      formData?.position ||
      dropdownValue.find(
        (role) => String(role?._id) === String(formData?.rolename),
      )?.roleName ||
      formData?.rolename?.roleName ||
      "";

    const needsWarehouse =
      WareHouseIncharge ||
      selectedRoleName === "WareHouse Incharge" ||
      (Array.isArray(SelectedWareHouse) && SelectedWareHouse.length > 0);

    if (!needsWarehouse) return;
    if (WareHouseList.length) return;
    if (warehouseDataRequestedRef.current) return;

    const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");
    if (!userInfo?.database) return;

    warehouseDataRequestedRef.current = true;

    _Get(Create_Warehouse_List, userInfo.database)
      .then((res) => setWareHouseList(res?.Warehouse || []))
      .catch(() => {
        warehouseDataRequestedRef.current = false;
      });
  }, [
    WareHouseIncharge,
    formData?.position,
    formData?.rolename,
    dropdownValue,
    SelectedWareHouse,
    WareHouseList.length,
  ]);

  // Shift and branch are used on the normal form. Start these after the first
  // paint and fetch them in parallel. The unused full country/state/city API
  // call was removed; pincode lookup already supplies City/State/Country.
  useEffect(() => {
    const userdata = JSON.parse(localStorage.getItem("userData") || "{}");
    if (!userdata?.database) return;

    const timer = setTimeout(() => {
      Promise.allSettled([
        _Get(Working_Hours_get, userdata.database),
        _Get(ListBranch, userdata.database),
      ]).then(([shiftResult, branchResult]) => {
        if (shiftResult.status === "fulfilled") {
          setShiftList(shiftResult.value?.WorkingHours || []);
        }

        if (branchResult.status === "fulfilled") {
          setBranch(branchResult.value?.Branch || []);
        }
      });
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  // add / remove role rows
  const handleAddMoreRows = () => {
    setRowCount((c) => c + 1);
    setFormData((prev) => ({
      ...prev,
      role: [
        ...(prev.role || []),
        {
          process: "",
          roleName: "",
          productAndPrice: [{ productName: "", price: "", stockUnit: "" }],
        },
      ],
    }));
  };

  const handleRemoveRole = (outerIndex) => {
    setFormData((prev) => {
      const role = (prev.role || []).slice();
      if (role.length > 1) role.splice(outerIndex, 1);
      return { ...prev, role };
    });
    setRowCount((c) => Math.max(1, c - 1));
  };

  const removeAddedProducts = (outerIndex, productIndex) => {
    setFormData((prev) => {
      const role = (prev.role || []).slice();
      const arr =
        role[outerIndex]?.productAndPrice?.filter(
          (_, idx) => idx !== productIndex,
        ) || [];
      role[outerIndex] = { ...role[outerIndex], productAndPrice: arr };
      return { ...prev, role };
    });
  };

  const onSelect1 = (selectedList) => setSelectedRoleToAssign(selectedList);
  const onRemove1 = (selectedList) => setSelectedRoleToAssign(selectedList);

  // ✅ ADD: rule multiselect handlers
  const onSelectRules = (selectedList) => SetRules(selectedList);
  const onRemoveRules = (selectedList) => SetRules(selectedList);

  const buildUserFormData = (sourceFormData, rowState = {}) => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const formdata = new FormData();
    const isCreateMode = String(Params?.id) === "0";

    const selectedRules = Array.isArray(rowState?.selectedRules)
      ? rowState.selectedRules
      : SelectedRules;
    const image = rowState?.image ?? Image;
    const selectedWarehouses = Array.isArray(rowState?.selectedWareHouse)
      ? rowState.selectedWareHouse
      : SelectedWareHouse;
    const warehouseIncharge = rowState?.wareHouseIncharge ?? WareHouseIncharge;
    const rowReferences = Array.isArray(rowState?.references)
      ? rowState.references
      : references;
    const rowSelectedItems = Array.isArray(rowState?.selectedItems)
      ? rowState.selectedItems
      : selectedItems;

    if (isCreateMode && !sourceFormData?.created_by && userData?._id) {
      formdata.append("created_by", userData._id);
    }

    let computedId = cleanBulkCell(sourceFormData?.id);
    if (!computedId) {
      const aadhaar = cleanBulkCell(sourceFormData?.Aadhar_No).replace(
        /\s+/g,
        "",
      );
      const pan = cleanBulkCell(sourceFormData?.Pan_No)
        .replace(/\s+/g, "")
        .toUpperCase();
      const mobile = String(sourceFormData?.mobileNumber || "").replace(
        /\D/g,
        "",
      );
      const namePart = String(sourceFormData?.firstName || "USER")
        .replace(/\s+/g, "")
        .toUpperCase();

      if (/^\d{12}$/.test(aadhaar)) {
        computedId = aadhaar;
      } else if (/^[A-Z]{5}\d{4}[A-Z]$/.test(pan)) {
        computedId = pan;
      } else if (mobile.length >= 4) {
        computedId = `${namePart}-${mobile.slice(-4)}`;
      } else {
        computedId = `${namePart}-${Date.now()
          .toString(36)
          .slice(-6)
          .toUpperCase()}`;
      }
    }
    formdata.append("id", computedId);

    if (Master) formdata.append("position", 1);

    if (selectedRules?.length || !isCreateMode) {
      formdata.append("setRule", JSON.stringify(selectedRules || []));
    }

    if (image) formdata.append("file", image);

    const warehouse = (selectedWarehouses || []).map((item) => ({
      id: item?._id || item?.id || item,
    }));

    if (warehouseIncharge || !isCreateMode) {
      formdata.append("warehouse", JSON.stringify(warehouse));
    }

    const isValidReferences =
      Array.isArray(rowReferences) &&
      rowReferences.length > 0 &&
      rowReferences.every((ref) => ref?.name && ref?.relation && ref?.mobile);

    if (isValidReferences) {
      formdata.append("reference", JSON.stringify(rowReferences));
    }

    const effectiveRoleName =
      sourceFormData?.position ||
      dropdownValue.find(
        (role) => String(role?._id) === String(sourceFormData?.rolename),
      )?.roleName ||
      "";

    if (
      effectiveRoleName === "Sales Person" ||
      effectiveRoleName === "Sales Manager"
    ) {
      formdata.append("serviceArea", JSON.stringify(rowSelectedItems || []));
    } else if (!isCreateMode) {
      // Clear old sales pincodes when the user's role changes away from sales.
      formdata.append("serviceArea", JSON.stringify([]));
    }

    formdata.set(
      "openingFinancialYear",
      normalizeOpeningFinancialYear(
        sourceFormData?.openingFinancialYear ||
          getCurrentOpeningFinancialYear(),
      ),
    );

    for (const [key, value] of Object.entries(sourceFormData || {})) {
      if (
        [
          "warehouse",
          "service",
          "serviceArea",
          "reference",
          "id",
          "openingFinancialYear",
          "setRule",
        ].includes(key) ||
        key.startsWith("_")
      ) {
        continue;
      }

      if (Master && key === "position") continue;
      if (isCreateMode && !sourceFormData?.created_by && key === "created_by") {
        continue;
      }
      if (sourceFormData?.position === "SuperAdmin" && key === "role") {
        continue;
      }

      if (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        continue;
      }

      if (key === "rolename" || key === "created_by") {
        formdata.append(key, value?._id ?? value);
      } else if (key === "role") {
        if (Array.isArray(value)) {
          const cleaned = value
            .map((roleItem) => {
              const productAndPrice = Array.isArray(roleItem?.productAndPrice)
                ? roleItem.productAndPrice
                    .map((product) => ({
                      productName: product?.productName || "",
                      price:
                        product?.price === "" || product?.price === undefined
                          ? ""
                          : Number(product?.price),
                      stockUnit: product?.stockUnit || "",
                    }))
                    .filter(
                      (product) =>
                        String(product.productName || "").trim().length > 0 &&
                        product.price !== "" &&
                        !Number.isNaN(product.price),
                    )
                : [];

              return {
                ...roleItem,
                process: roleItem?.process || "",
                roleName: roleItem?.roleName || "",
                productAndPrice,
              };
            })
            .filter(
              (roleItem) =>
                String(roleItem?.process || "").trim().length > 0 &&
                String(roleItem?.roleName || "").trim().length > 0,
            );

          if (cleaned.length > 0) {
            formdata.append("role", JSON.stringify(cleaned));
          }
        }
      } else if (typeof value === "object") {
        formdata.append(key, JSON.stringify(value));
      } else {
        formdata.append(key, value);
      }
    }

    return formdata;
  };

  // ===== submit (account mode handled first) =====
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    if (!BulkUpload && formData.account) {
      try {
        const obj = {
          account: formData.account,
          firstName: formData.firstName,
          OpeningBalance: formData.OpeningBalance,
          openingFinancialYear: normalizeOpeningFinancialYear(
            formData.openingFinancialYear || getCurrentOpeningFinancialYear(),
          ),
          Type: formData?.Type,
          database: userData.database,
          created_by: userData?._id,
          id: `${formData.firstName || ""}-${formData.account || ""}`,
        };

        if (String(Params?.id) === "0") {
          const res = await CreateAccountSave(obj);
          if (res?.status) {
            swal("User Account Saved Successfully");
            goBack();
            return;
          }
          swal("Error in Saving User Account");
        } else {
          const res = await CreateAccountUpdate(Params?.id, obj);
          if (res?.status) {
            swal("User Account Updated Successfully");
            goBack();
            return;
          }
          swal("Error in Updating User Account");
        }
      } catch {
        swal("User ID is important!", "error");
      } finally {
        setLoading(false);
      }
      return;
    }

    const currentBulkItem =
      BulkUpload && activeBulkIndex >= 0
        ? getCurrentBulkSnapshot(bulkUsers?.[activeBulkIndex] || {})
        : null;

    const rowState = currentBulkItem || {
      references,
      selectedRules: SelectedRules,
      selectedWareHouse: SelectedWareHouse,
      selectedItems,
      assignedTo,
      image: Image,
      wareHouseIncharge: WareHouseIncharge,
      selectedRoleToAssign: SelectedRoleToAssign,
    };

    const formdata = buildUserFormData(formData, rowState);

    try {
      if (BulkUpload && activeBulkIndex >= 0 && bulkUsers.length > 0) {
        setBulkSavingIndex(activeBulkIndex);
        setBulkUsers((previous) =>
          previous.map((item, itemIndex) =>
            itemIndex === activeBulkIndex ? currentBulkItem : item,
          ),
        );

        await finalizeSubmit(formdata, {
          navigateAfter: false,
          silent: true,
          sourceFormData: formData,
          assignedParentId: currentBulkItem?.assignedTo || assignedTo,
          selectedRoleToAssign:
            currentBulkItem?.selectedRoleToAssign || SelectedRoleToAssign,
        });

        const savedIndex = activeBulkIndex;
        clearSavedBulkUser(savedIndex);
        swal("Saved", "User saved successfully", "success");
        return;
      }

      await finalizeSubmit(formdata);
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || "Something went wrong";

      if (BulkUpload && activeBulkIndex >= 0) {
        setBulkUsers((previous) =>
          previous.map((item, itemIndex) =>
            itemIndex === activeBulkIndex
              ? {
                  ...(currentBulkItem || item),
                  errorMessage: message,
                }
              : item,
          ),
        );
      }

      console.log(err?.response?.data || err);
      swal("Error", message, "error");
    } finally {
      setBulkSavingIndex(null);
      setLoading(false);
    }
  };

  // ---------- helpers for role->product pricing ----------
  const handleAddProduct = (outerIndex) => {
    setFormData((prev) => {
      const role = (prev.role || []).slice();
      const list = role[outerIndex]?.productAndPrice || [];
      role[outerIndex] = {
        ...(role[outerIndex] || {}),
        productAndPrice: [
          ...list,
          { productName: "", price: "", stockUnit: "" },
        ],
      };
      return { ...prev, role };
    });
  };

  const handleProductChange = (outerIndex, productIndex, field, value) => {
    setFormData((prev) => {
      const role = (prev.role || []).slice();
      const rp = (role[outerIndex]?.productAndPrice || []).slice();
      const item = { ...(rp[productIndex] || {}) };

      if (field === "productName") {
        item.productName = value;
        const stock =
          (productName || []).find((p) => p.Product_Title === value)
            ?.stockUnit || "";
        item.stockUnit = stock;
      } else if (field === "price") {
        item.price = value === "" ? "" : parseFloat(value);
      } else {
        item[field] = value;
      }
      rp[productIndex] = item;
      role[outerIndex] = { ...(role[outerIndex] || {}), productAndPrice: rp };
      return { ...prev, role };
    });
  };

  // ---------- finalize submit ----------
  const finalizeSubmit = async (formdata, options = {}) => {
    const {
      navigateAfter = true,
      silent = false,
      sourceFormData = formData,
      assignedParentId = assignedTo,
      selectedRoleToAssign = SelectedRoleToAssign,
      manageLoader = true,
      manageLoading = true,
    } = options;

    if (manageLoader) setLoader(true);
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    try {
      if (String(Params?.id) === "0") {
        const res = await CreateAccountSave(formdata);
        if (!res?.status) {
          throw new Error(res?.message || "Create failed");
        }

        const createdUserId =
          res?.User?._id || res?.user?._id || res?.data?._id || "";

        if (assignedParentId && createdUserId) {
          try {
            await _PostSave(User_Assign_User, {
              parentId: assignedParentId,
              childs: [{ id: createdUserId }],
            });
          } catch {}
        }

        if (
          Master &&
          Array.isArray(selectedRoleToAssign) &&
          selectedRoleToAssign.length
        ) {
          const AssignDataBase = selectedRoleToAssign.map((ele) => ({
            role: {
              roleName: ele?.roleName,
              position: 0,
              desc: ele?.desc,
              id: ele?.id,
              rank: 0,
              rolePermission: ele?.rolePermission,
              database: sourceFormData?.database,
              createdBy: userData?._id,
            },
          }));

          try {
            await _PostSave(Assign_Role_To_SuperAdmin, {
              Roles: JSON.stringify(AssignDataBase),
            });
          } catch {}
        }

        if (!silent) {
          swal(
            Master
              ? "SuperAdmin created successfully"
              : "User created successfully",
          );
        }
        if (navigateAfter) goBack();
        return res;
      }

      const res = await CreateAccountUpdate(Params?.id, formdata);
      if (!res?.status) {
        throw new Error(res?.message || "Update failed");
      }

      if (
        Master &&
        Array.isArray(selectedRoleToAssign) &&
        selectedRoleToAssign.length
      ) {
        const AssignDataBase = selectedRoleToAssign.map((ele) => ({
          role: {
            roleName: ele?.roleName,
            position: 0,
            desc: ele?.desc,
            id: ele?.id,
            rank: 0,
            rolePermission: ele?.rolePermission,
            database: sourceFormData?.database,
            createdBy: userData?._id,
          },
        }));

        try {
          await _PostSave(Update_Role_To_SuperAdmin, {
            Roles: JSON.stringify(AssignDataBase),
            userId: Params?.id,
          });
        } catch (e) {
          try {
            await _PostSave(Assign_Role_To_SuperAdmin, {
              Roles: JSON.stringify(AssignDataBase),
            });
          } catch {}
        }
      }

      if (!silent) swal("User updated successfully");
      if (navigateAfter) goBack();
      return res;
    } finally {
      if (manageLoader) setLoader(false);
      if (manageLoading) setLoading(false);
    }
  };

  const handleSaveAllBulkUsers = async () => {
    if (!bulkUsers.length) return;

    const confirmed = await swal({
      title: "Save all users?",
      text: `${bulkUsers.length} user(s) will be created. Saved rows will be removed and failed rows will remain.`,
      icon: "warning",
      buttons: ["Cancel", "Save All"],
    });

    if (!confirmed) return;

    const synced = bulkUsers.map((item, itemIndex) =>
      itemIndex === activeBulkIndex ? getCurrentBulkSnapshot(item) : item,
    );
    setBulkUsers(synced);
    setBulkSaveAllLoading(true);
    setLoader(true);
    setLoading(true);

    let saved = 0;
    let failed = 0;
    const failedRows = [];

    for (const item of synced) {
      try {
        const data = item?.data || {};
        const formdata = buildUserFormData(data, item);

        await finalizeSubmit(formdata, {
          navigateAfter: false,
          silent: true,
          sourceFormData: data,
          assignedParentId: item?.assignedTo || null,
          selectedRoleToAssign: item?.selectedRoleToAssign || [],
          manageLoader: false,
          manageLoading: false,
        });
        saved += 1;
      } catch (err) {
        failed += 1;
        failedRows.push({
          ...item,
          errorMessage:
            err?.response?.data?.message || err?.message || "User save failed",
        });
      }
    }

    setBulkUsers(failedRows);

    if (failedRows.length) {
      setExpandedBulkIndex(0);
      loadBulkUserIntoEditor(failedRows[0], 0);
    } else {
      setExpandedBulkIndex(null);
      setActiveBulkIndex(-1);
      resetBulkEditor();
    }

    setBulkSaveAllLoading(false);
    setLoader(false);
    setLoading(false);

    swal(
      "Bulk Save Completed",
      `Saved: ${saved}\nFailed: ${failed}`,
      failed ? "warning" : "success",
    );
  };

  // ---------- UI toggles ----------
  const currentRoleName =
    formData?.position ||
    dropdownValue.find((r) => String(r?._id) === String(formData?.rolename))
      ?.roleName ||
    formData?.rolename?.roleName ||
    "";

  const showRolePricing = ROLE_PRICING_NAMES.includes(currentRoleName);

  // Visible edit-mode summaries. These are shown on the page, not only restored in state.
  const currentAssignmentDepartment = (DepartmentWithRole || []).find(
    (department) =>
      String(department?._id) === String(SelectedDepartments || ""),
  );

  const currentAssignmentDepartmentName =
    currentAssignmentDepartment?.departmentName?.departmentName ||
    currentAssignmentDepartment?.departmentName ||
    "-";

  const currentAssignmentRole = (SelectedDepartment || []).find(
    (role) => String(role?._id) === String(Parent || ""),
  );

  const currentAssignmentRoleName =
    currentAssignmentRole?.roleName ||
    ParentName ||
    getUserRoleName(currentAssignedParent) ||
    "-";

  const visibleServiceAreas = (() => {
    const source =
      Array.isArray(selectedItems) && selectedItems.length
        ? selectedItems
        : Array.isArray(formData?.serviceArea) && formData.serviceArea.length
          ? formData.serviceArea
          : formData?.service;

    const parsed = parseBulkService(source);
    const seen = new Set();

    return parsed.filter((item) => {
      const pincode = String(
        typeof item === "object" ? item?.pincode || "" : item || "",
      ).trim();

      if (!pincode || seen.has(pincode)) return false;
      seen.add(pincode);
      return true;
    });
  })();

  const visibleWarehouses = (SelectedWareHouse || [])
    .map((warehouse) => {
      if (
        warehouse &&
        typeof warehouse === "object" &&
        warehouse.warehouseName
      ) {
        return warehouse;
      }

      const warehouseId =
        typeof warehouse === "object"
          ? warehouse?._id || warehouse?.id || warehouse?.warehouseId
          : warehouse;

      return (WareHouseList || []).find(
        (option) => String(option?._id) === String(warehouseId),
      );
    })
    .filter(Boolean);

  const currentShift = (shiftList || []).find(
    (shift) => String(shift?._id) === String(formData?.shift || ""),
  );

  const currentBranch = (Branch || []).find(
    (branch) => String(branch?._id) === String(formData?.branch || ""),
  );

  const handleDelete = (id) => {
    swal("Warning", "Sure You Want to Delete it", {
      buttons: { cancel: "cancel", catch: { text: "Delete", value: "delete" } },
    }).then((value) => {
      if (value === "delete") {
        DeleteAccount(id)
          .then(() => {
            goBack();
          })
          .catch(() => {});
      }
    });
  };

  const renderUserFormFields = () => (
    <>
      {/* ===== Main two-column sections ===== */}
      <Row className="mt-1">
        {/* LEFT: Personal Info */}
        <Col lg="6" md="12">
          <CardBody className="userRegiBody">
            <div className="d-flex justify-content-center">
              <h1>Personal Information</h1>
            </div>
            <Row>
              <Col lg="6" md="6" sm="12">
                <FormGroup className="cssforproductlist">
                  <Label>
                    Full Name <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    required
                    placeholder="Enter Full Name"
                    name="firstName"
                    value={formData?.firstName || ""}
                    onChange={(e) =>
                      setFormData((p) => ({
                        ...p,
                        firstName: e.target.value.toUpperCase(),
                      }))
                    }
                  />
                </FormGroup>
              </Col>

              {/* Account-ledger path */}
              <Col lg="6" md="6" sm="12">
                <FormGroup className="cssforproductlist">
                  <Label>Account</Label>
                  <Input
                    type="select"
                    name="account"
                    value={formData?.account || ""}
                    onChange={(e) =>
                      setFormData((p) => ({
                        ...p,
                        account: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select Account</option>
                    <option value="Capital Account">Capital Account</option>
                    <option value="Reserves and Surplus">
                      Reserves and Surplus
                    </option>
                    <option value="Current Liabilities">
                      Current Liabilities
                    </option>
                    <option value="Sundry Creditors">Sundry Creditors</option>
                    <option value="Duties and Taxes">Duties and Taxes</option>
                    <option value="Provisions">Provisions</option>
                    <option value="Bank OCC Account">Bank OCC Account</option>
                    <option value="Bank OD Account">Bank OD Account</option>
                    <option value="Secured Loans">Secured Loans</option>
                    <option value="Unsecured Loans">Unsecured Loans</option>
                    <option value="Deposits (Liability)">
                      Deposits (Liability)
                    </option>
                    <option value="Fixed Assets">Fixed Assets</option>
                    <option value="Investments">Investments</option>
                    <option value="Current Assets">Current Assets</option>
                    <option value="Bank Accounts">Bank Accounts</option>
                    <option value="Cash-in-Hand">Cash-in-Hand</option>
                    <option value="Deposits (Asset)">Deposits (Asset)</option>
                    <option value="Loans and Advances (Asset)">
                      Loans and Advances (Asset)
                    </option>
                    <option value="Stock-in-Hand">Stock-in-Hand</option>
                    <option value="Sundry Debtors">Sundry Debtors</option>
                    <option value="Sales Account">Sales Account</option>
                    <option value="Purchase Account">Purchase Account</option>
                    <option value="Direct Incomes">Direct Incomes</option>
                    <option value="Indirect Incomes">Indirect Incomes</option>
                    <option value="Direct Expenses">Direct Expenses</option>
                    <option value="Indirect Expenses">Indirect Expenses</option>
                    <option value="Branch/Divisions">Branch/Divisions</option>
                    <option value="Misc. Expenses (Asset)">
                      Misc. Expenses (Asset)
                    </option>
                  </Input>
                </FormGroup>
              </Col>

              {formData?.account && (
                <>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Opening Balance</Label>
                      <Input
                        type="number"
                        name="OpeningBalance"
                        value={formData?.OpeningBalance || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            OpeningBalance: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>O/P Balance Type</Label>
                      <Input
                        type="select"
                        name="Type"
                        value={formData?.Type || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            Type: e.target.value,
                          }))
                        }
                      >
                        <option value="">----select Type----</option>
                        <option value="debit">Dr</option>
                        <option value="credit">Cr</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </>
              )}

              {!formData?.account && (
                <>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>DOB</Label>
                      <Input
                        type="date"
                        name="DOB"
                        value={formData?.DOB || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            DOB: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Mobile Number</Label>
                      <PhoneInput
                        inputClass="myphoneinput"
                        country="in"
                        countryCodeEditable={false}
                        value={formData?.mobileNumber || ""}
                        onChange={(val) =>
                          setFormData((p) => ({
                            ...p,
                            mobileNumber: val,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>

                  {/* Email + Password on same row */}
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>
                        Email <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        required
                        type="email"
                        name="email"
                        placeholder="Enter Email"
                        value={formData?.email || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            email: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Password</Label>
                      <Input
                        type="password"
                        name="password"
                        placeholder="Enter Password"
                        value={formData?.password || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            password: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>

                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Father Name</Label>
                      <Input
                        name="Father_name"
                        placeholder="Enter Father name"
                        value={formData?.Father_name || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            Father_name: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Father Mobile Number</Label>
                      <PhoneInput
                        inputClass="myphoneinput"
                        country="in"
                        countryCodeEditable={false}
                        value={formData?.Father_MobileNo || ""}
                        onChange={(val) =>
                          setFormData((p) => ({
                            ...p,
                            Father_MobileNo: val,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Mother Mobile Number</Label>
                      <PhoneInput
                        inputClass="myphoneinput"
                        country="in"
                        countryCodeEditable={false}
                        value={formData?.MotherMobileNo || ""}
                        onChange={(val) =>
                          setFormData((p) => ({
                            ...p,
                            MotherMobileNo: val,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Driving License Number</Label>
                      <Input
                        name="DL_Num"
                        placeholder="Enter DL Number"
                        value={formData?.DL_Num || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            DL_Num: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>

                  {/* PAN & Aadhar */}
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Aadhar Number</Label>
                      <Input
                        minLength={12}
                        maxLength={12}
                        pattern="[0-9]*"
                        name="Aadhar_No"
                        placeholder="Enter Aadhar Number"
                        value={formData?.Aadhar_No || ""}
                        onChange={(e) => {
                          const v = e.target.value;
                          const ok = /^\d{12}$/.test(v);
                          setFormData((p) => ({
                            ...p,
                            Aadhar_No: v,
                            IsValid_Aadhar_No: ok,
                          }));
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Pan Number</Label>
                      <Input
                        minLength={10}
                        maxLength={10}
                        name="Pan_No"
                        placeholder="Enter Pan Number"
                        value={formData?.Pan_No || ""}
                        onChange={(e) => {
                          const v = e.target.value.toUpperCase();
                          const ok = /[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(v);
                          setFormData((p) => ({
                            ...p,
                            Pan_No: v,
                            IsValid_Pan_No: ok,
                          }));
                        }}
                      />
                    </FormGroup>
                  </Col>

                  {/* Bank */}
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Bank Name</Label>
                      <Input
                        name="Account_Name"
                        placeholder="Enter Bank Name"
                        value={formData?.Account_Name || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            Account_Name: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Account Number</Label>
                      <Input
                        name="Account_No"
                        placeholder="Enter Account Number"
                        value={formData?.Account_No || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            Account_No: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>IFSC Code</Label>
                      <Input
                        name="Ifsc_code"
                        placeholder="Enter IFSC code"
                        value={formData?.Ifsc_code || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            Ifsc_code: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>

                  {/* Address via pincode */}
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Pin Code</Label>
                      <Input
                        type="number"
                        name="pincode"
                        placeholder="Enter Pin Code"
                        value={formData?.pincode || ""}
                        onChange={handlePincodeChange} // ✅ CHANGED: uses new 6-digit + multi-city logic
                      />
                    </FormGroup>
                  </Col>

                  {/* ✅ NEW: If multiple cities for same pincode -> show dropdown, else readOnly City */}
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>City</Label>

                      {showCityDropdown ? (
                        <Input
                          type="select"
                          value={selectedCityValue || ""}
                          onChange={(e) =>
                            handleCitySelectForPincode(e.target.value)
                          }
                        >
                          <option value="">Select City</option>
                          {(cityOptions || []).map((c, idx) => (
                            <option
                              key={`${c?.pincode}-${c?.city}-${idx}`}
                              value={c?.city}
                            >
                              {c?.city} - {c?.district}
                            </option>
                          ))}
                        </Input>
                      ) : (
                        <Input readOnly value={formData?.City || ""} />
                      )}
                    </FormGroup>
                  </Col>

                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>State</Label>
                      <Input readOnly value={formData?.State || ""} />
                    </FormGroup>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Country</Label>
                      <Input readOnly value={formData?.Country || ""} />
                    </FormGroup>
                  </Col>

                  {/* Address + Image */}
                  <Col lg="6" md="6" sm="12">
                    <FormGroup className="cssforproductlist">
                      <Label>Address</Label>
                      <Input
                        name="address1"
                        placeholder="Enter Address"
                        value={formData?.address1 || ""}
                        onChange={(e) =>
                          setFormData((p) => ({
                            ...p,
                            address1: e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>

                  {/* <Col lg="12" md="12" sm="12" className="mt-2">
                    <Row>
                      <Col lg="6" md="12" sm="12">
                        <div className="d-flex justify-content-center">
                          <Label>Image</Label>
                        </div>
                        <div className="parent">
                          <div className="file-upload">
                            <p className="mb-1" style={{ fontWeight: 700 }}>
                              Click box to upload
                            </p>
                            <p
                              className="mb-2"
                              style={{ fontSize: 12, opacity: 0.7 }}
                            >
                              Max 1 MB
                            </p>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const f = e.target.files?.[0];
                                if (f) {
                                  const sizeMB = f.size / (1024 * 1024);
                                  if (sizeMB > 1) {
                                    swal(
                                      "Error",
                                      "The file is larger than 1 MB.",
                                      "error",
                                    );
                                    return;
                                  }
                                  setImage(f);
                                  const reader = new FileReader();
                                  reader.onload = (ev) => {
                                    setFormData((p) => ({
                                      ...p,
                                      imageuri: ev.target.result,
                                    }));
                                  };
                                  reader.readAsDataURL(f);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Col>

                      {formData?.imageuri && (
                        <Col
                          lg="6"
                          md="12"
                          sm="12"
                          className="d-flex align-items-center"
                        >
                          <img
                            style={{ borderRadius: 8 }}
                            src={formData?.imageuri}
                            alt="preview"
                            height={100}
                            width={120}
                          />
                        </Col>
                      )}
                    </Row>
                  </Col> */}
                </>
              )}
            </Row>
          </CardBody>
        </Col>

        {/* RIGHT: Assign / Last work / Reference / Official */}
        <Col lg="6" md="12">
          {/* Assign Member */}
          {!Master && !formData?.account && (
            <CardBody className="userRegiBody">
              <div className="d-flex justify-content-center">
                <h2>Assign Member</h2>
              </div>
              <Row>
                {/* {String(Params?.id) !== "0" && (
                  <Col lg="12" md="12" sm="12" className="mb-2">
                    <div
                      style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        padding: "10px 12px",
                        background: "#f8fafc",
                      }}
                    >
                      <Label style={{ fontWeight: 700, marginBottom: 8 }}>
                        Current Assignment
                      </Label>

                      {currentAssignedParent ? (
                        <Row>
                          <Col lg="3" md="6" sm="12" className="mb-1">
                            <div style={{ color: "#64748b", fontSize: 11 }}>
                              Department
                            </div>
                            <strong>{currentAssignmentDepartmentName}</strong>
                          </Col>
                          <Col lg="3" md="6" sm="12" className="mb-1">
                            <div style={{ color: "#64748b", fontSize: 11 }}>
                              Parent Role
                            </div>
                            <strong>{currentAssignmentRoleName}</strong>
                          </Col>
                          <Col lg="3" md="6" sm="12" className="mb-1">
                            <div style={{ color: "#64748b", fontSize: 11 }}>
                              Assigned Member
                            </div>
                            <strong>
                              {getUserDisplayName(currentAssignedParent)}
                            </strong>
                          </Col>
                          <Col lg="3" md="6" sm="12" className="mb-1">
                            <div style={{ color: "#64748b", fontSize: 11 }}>
                              Designation
                            </div>
                            <strong>
                              {getUserRoleName(currentAssignedParent) || "-"}
                            </strong>
                          </Col>
                        </Row>
                      ) : (
                        <Badge color="secondary">Not Assigned</Badge>
                      )}
                    </div>
                  </Col>
                )} */}

                <Col lg="6" md="6" sm="12">
                  <FormGroup className="cssforproductlist">
                    <Label>Select Department</Label>
                    <Input
                      type="select"
                      value={SelectedDepartments}
                      onChange={(e) => {
                        const depId = e.target.value;
                        setSelectedDepartments(depId);
                        setShow(!!depId);
                        setChild(false);
                        setShowParentList([]);
                        setTableDataList([]);
                        setParent("");
                        setNames("");
                        setAssignedTo(null);
                        setCurrentAssignedParent(null);
                        if (!depId) {
                          setSelectedDepartment([]);
                          return;
                        }
                        const d = (DepartmentWithRole || []).find(
                          (x) => String(x?._id) === String(depId),
                        );
                        setSelectedDepartment(d?.roles || []);
                      }}
                    >
                      <option value="">Select Department</option>
                      {(DepartmentWithRole || []).map((ele) => (
                        <option key={ele?._id} value={ele?._id}>
                          {ele?.departmentName?.departmentName}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                <Col lg="6" md="6" sm="12">
                  <FormGroup className="cssforproductlist">
                    <Label>Select Parent Role</Label>
                    <Input
                      type="select"
                      value={Parent}
                      onChange={async (e) => {
                        const val = e.target.value;
                        setParent(val);
                        setAssignedTo(null);
                        setNames("");
                        setCurrentAssignedParent(null);

                        if (!val) {
                          setChild(false);
                          setShowParentList([]);
                          setTableDataList([]);
                          return;
                        }

                        const roleItem = (SelectedDepartment || []).find(
                          (r) => String(r?._id) === String(val),
                        );

                        if (!roleItem) {
                          setChild(false);
                          setShowParentList([]);
                          setTableDataList([]);
                          return;
                        }

                        const rolePosition = Number(
                          roleItem?.rolePosition || 0,
                        );
                        const roleName = roleItem?.roleName || "";
                        const roleId = roleItem?.roleId?._id;

                        setParentName(roleName);
                        setSelectedRoleId(roleId);

                        // All users is one of the heaviest responses on this
                        // page. Load it only when a parent role is selected.
                        const users =
                          AllUsersList.length > 0
                            ? AllUsersList
                            : await UserList();

                        const ParentList = (users || []).filter(
                          (u) => String(u?.rolename?._id) === String(roleId),
                        );

                        setShowParentList(ParentList);
                        setTableDataList(ParentList);

                        const childRoles = (SelectedDepartment || []).filter(
                          (r) => Number(r?.rolePosition) === rolePosition + 1,
                        );

                        if (childRoles?.length) {
                          const firstChildRoleId = childRoles[0]?.roleId?._id;
                          const childs = (users || []).filter(
                            (u) =>
                              String(u?.rolename?._id) ===
                              String(firstChildRoleId),
                          );

                          setShowChildList(childs);
                          setGetChildList(childs);
                          setChild(true);
                        } else {
                          setShowChildList([]);
                          setChild(false);
                        }
                      }}
                    >
                      <option value="">-- Select Role --</option>
                      {(SelectedDepartment || []).map((r) => (
                        <option key={r?._id} value={r?._id}>
                          {r?.roleName} (Position-{r?.rolePosition})
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                <div
                  className="p-1 w-100"
                  style={{ borderRight: "1px solid #eee" }}
                >
                  <Table responsive hover className="table_heading">
                    <thead>
                      <tr>
                        <th>Assigned To</th>
                        <th>Name</th>
                        {ShowParentList?.[0]?.rolename?.roleName ===
                        "Sales Person" ? (
                          <>
                            <th>Area</th>
                            <th>Designation</th>
                          </>
                        ) : (
                          <th>Designation</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {ShowParentList?.slice(0, 1)?.map((ele) => (
                        <tr key={ele?._id}>
                          <td>
                            {ele?.created_by?.firstName && (
                              <strong style={{ fontSize: 16 }}>
                                {ele?.created_by?.firstName}
                              </strong>
                            )}
                          </td>
                          <td>
                            <Input
                              type="select"
                              value={names}
                              onChange={handleDropList}
                            >
                              <option value="">Select Name</option>
                              {(tableDataList || []).map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {getUserDisplayName(item)}
                                </option>
                              ))}
                            </Input>
                          </td>
                          {ele?.rolename?.roleName === "Sales Person" ? (
                            <>
                              <td>{ele?.area || "-"}</td>
                              <td>{ele?.rolename?.roleName || "-"}</td>
                            </>
                          ) : (
                            <td>{ele?.rolename?.roleName || "-"}</td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {String(Params?.id) !== "0" && (
                  <div className="w-100 d-flex justify-content-end mt-2">
                    <Button
                      type="button"
                      color="primary"
                      onClick={handleAssignMemberSubmit}
                    >
                      Update Assignment
                    </Button>
                  </div>
                )}
              </Row>
            </CardBody>
          )}

          {/* Last Working Details */}
          {!Master && !formData?.account && (
            <CardBody className="userRegiBody">
              <div className="d-flex justify-content-center">
                <h1>Last Working Details</h1>
              </div>
              <Row>
                <Col lg="6" md="6" sm="12">
                  <FormGroup className="cssforproductlist">
                    <Label>Firm Name</Label>
                    <Input
                      name="last_job_firm_name"
                      placeholder="Last job firm name"
                      value={formData?.last_job_firm_name || ""}
                      onChange={(e) =>
                        setFormData((p) => ({
                          ...p,
                          last_job_firm_name: e.target.value,
                        }))
                      }
                    />
                  </FormGroup>
                </Col>
                <Col lg="6" md="6" sm="12">
                  <FormGroup className="cssforproductlist">
                    <Label>Profile Name</Label>
                    <Input
                      name="last_job_Profile"
                      placeholder="Last job profile name"
                      value={formData?.last_job_Profile || ""}
                      onChange={(e) =>
                        setFormData((p) => ({
                          ...p,
                          last_job_Profile: e.target.value,
                        }))
                      }
                    />
                  </FormGroup>
                </Col>
                <Col lg="6" md="6" sm="12">
                  <FormGroup className="cssforproductlist">
                    <Label>Address</Label>
                    <Input
                      name="last_job_address"
                      placeholder="Last job address"
                      value={formData?.last_job_address || ""}
                      onChange={(e) =>
                        setFormData((p) => ({
                          ...p,
                          last_job_address: e.target.value,
                        }))
                      }
                    />
                  </FormGroup>
                </Col>
                <Col lg="6" md="6" sm="12">
                  <FormGroup className="cssforproductlist">
                    <Label>Contact Number</Label>
                    <PhoneInput
                      inputClass="myphoneinput"
                      country="in"
                      countryCodeEditable={false}
                      value={formData?.last_job_PhNo || ""}
                      onChange={(val) =>
                        setFormData((p) => ({
                          ...p,
                          last_job_PhNo: val,
                        }))
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          )}

          {/* Reference */}
          {!Master && !formData?.account && (
            <CardBody className="userRegiBody">
              <div className="d-flex justify-content-center">
                <h2>Reference Information</h2>
              </div>
              {(references || []).map((ref, idx) => (
                <Row key={ref.id} className="align-items-end mb-2">
                  <Col lg="5" md="5" sm="12">
                    <FormGroup>
                      <Label>Name</Label>
                      <Input
                        placeholder="Reference Name"
                        value={ref.name}
                        onChange={(e) =>
                          handleReferenceInputChange(
                            ref.id,
                            "name",
                            e.target.value,
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="4" md="4" sm="12">
                    <FormGroup>
                      <Label>Relation</Label>
                      <Input
                        placeholder="Reference Relation"
                        value={ref.relation}
                        onChange={(e) =>
                          handleReferenceInputChange(
                            ref.id,
                            "relation",
                            e.target.value,
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="3" md="3" sm="12">
                    <FormGroup>
                      <Label>Mobile</Label>
                      <PhoneInput
                        inputClass="myphoneinput"
                        country="in"
                        countryCodeEditable={false}
                        value={ref.mobile}
                        onChange={(val) =>
                          handleReferenceInputChange(ref.id, "mobile", val)
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col
                    lg="2"
                    md="2"
                    sm="12"
                    className="d-flex justify-content-center"
                  >
                    {idx > 0 && (
                      <Button
                        color="danger"
                        onClick={() => removeReference(ref.id)}
                      >
                        Remove
                      </Button>
                    )}
                  </Col>
                </Row>
              ))}
              <div className="w-100 d-flex justify-content-end">
                <Button color="primary" onClick={addReference}>
                  Add More
                </Button>
              </div>
            </CardBody>
          )}

          {/* Official information */}
          {!formData?.account && (
            <CardBody className="userRegiBody">
              <div className="d-flex justify-content-center">
                <h1>Official Information</h1>
              </div>

              {/* {String(Params?.id) !== "0" && (
              )} */}

              <Row>
                {/* Role select */}
                <Col lg="6" md="6" sm="12">
                  <FormGroup className="cssforproductlist">
                    <Label>
                      Select Role <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      required
                      type="select"
                      name="rolename"
                      value={formData?.rolename || ""}
                      onChange={(e) => {
                        const option = e.target.options[e.target.selectedIndex];
                        const roleName = option.getAttribute("data-rolename");
                        if (roleName === "WareHouse Incharge") {
                          setWareHouseIncharge(true);
                        } else {
                          setWareHouseIncharge(false);
                          setSelectedWareHouse([]);
                        }

                        if (
                          roleName !== "Sales Person" &&
                          roleName !== "Sales Manager"
                        ) {
                          setSelectedItems([]);
                        }

                        if (/admin/i.test(roleName || "")) {
                          const userdata = JSON.parse(
                            localStorage.getItem("userData"),
                          );
                          setFormData((p) => ({
                            ...p,
                            created_by: userdata?._id,
                          }));
                        }
                        setFormData((p) => ({
                          ...p,
                          rolename: e.target.value,
                          position: roleName,
                        }));
                        if (
                          roleName === "Sales Person" ||
                          roleName === "Sales Manager"
                        )
                          toggle();
                      }}
                    >
                      {!Master && <option value="">--select Role--</option>}
                      {!!formData?.rolename &&
                        !(dropdownValue || []).some(
                          (role) =>
                            String(role?._id) === String(formData?.rolename),
                        ) && (
                          <option
                            value={formData?.rolename}
                            data-rolename={currentRoleName}
                          >
                            {currentRoleName || "Current Role"}
                          </option>
                        )}
                      {(dropdownValue || []).map((r) => (
                        <option
                          key={r?._id}
                          value={r?._id}
                          data-rolename={r?.roleName}
                        >
                          {r?.roleName}
                        </option>
                      ))}
                    </Input>

                    {(currentRoleName === "Sales Person" ||
                      currentRoleName === "Sales Manager") && (
                      <div className="d-flex align-items-center gap-2 mt-1">
                        <Button
                          type="button"
                          color="link"
                          style={{ padding: 0, textDecoration: "none" }}
                          onClick={toggle}
                        >
                          Select Service Area
                        </Button>
                        <Badge color="primary">
                          Selected: {visibleServiceAreas.length}
                        </Badge>
                      </div>
                    )}
                  </FormGroup>
                </Col>

                {(currentRoleName === "Sales Person" ||
                  currentRoleName === "Sales Manager") && (
                  <Col lg="12" md="12" sm="12" className="mb-2">
                    <div
                      style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        padding: "10px 12px",
                        background: "#fff",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <Label style={{ fontWeight: 700, marginBottom: 0 }}>
                          Assigned Service Areas / Pincodes
                        </Label>
                        <Badge color="primary">
                          {visibleServiceAreas.length} selected
                        </Badge>
                      </div>

                      {visibleServiceAreas.length ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 6,
                            maxHeight: 160,
                            overflowY: "auto",
                          }}
                        >
                          {visibleServiceAreas.map((service, serviceIndex) => {
                            const pincode = String(
                              typeof service === "object"
                                ? service?.pincode || ""
                                : service || "",
                            ).trim();
                            const place = [
                              service?.city,
                              service?.district,
                              service?.state,
                            ]
                              .filter(Boolean)
                              .join(", ");

                            return (
                              <span
                                key={`${pincode}-${serviceIndex}`}
                                title={place || pincode}
                                style={{
                                  border: "1px solid #cbd5e1",
                                  borderRadius: 999,
                                  padding: "4px 9px",
                                  background: "#f8fafc",
                                  fontSize: 12,
                                  fontWeight: 600,
                                }}
                              >
                                {pincode || "-"}
                                {place ? ` - ${place}` : ""}
                              </span>
                            );
                          })}
                        </div>
                      ) : (
                        <span style={{ color: "#64748b", fontSize: 12 }}>
                          No service area assigned
                        </span>
                      )}
                    </div>
                  </Col>
                )}

                {/* Rules multiselect */}
                <Col lg="6" md="6" sm="12">
                  <div className="cssforproductlist">
                    <Label>Select Rules</Label>
                    <Multiselect
                      showCheckbox
                      isObject
                      options={ruleOptions}
                      selectedValues={selectedRuleValues}
                      displayValue="ruleName"
                      onSelect={onSelectRules}
                      onRemove={onRemoveRules}
                    />
                  </div>
                </Col>

                {/* Shift / Branch (non-Master) */}
                {!Master && (
                  <>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup className="cssforproductlist">
                        <Label>
                          Select Shift <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="select"
                          name="shift"
                          value={formData?.shift || ""}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              shift: e.target.value,
                            }))
                          }
                        >
                          <option value="">--select Shift--</option>
                          {(shiftList || []).map((sh) => (
                            <option key={sh?._id} value={sh?._id}>
                              {sh?.shiftName} ({sh?.fromTime}-{sh?.toTime})
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup className="cssforproductlist">
                        <Label>
                          Select Branch <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="select"
                          name="branch"
                          value={formData?.branch || ""}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              branch: e.target.value,
                            }))
                          }
                        >
                          <option value="">--select Branch--</option>
                          {(Branch || []).map((b) => (
                            <option key={b?._id} value={b?._id}>
                              {b?.branchName} ({b?.city})
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </>
                )}

                {/* Warehouse incharge */}
                {WareHouseIncharge && (
                  <Col className="mb-1" lg="6" md="6" sm="12">
                    <div className="cssforproductlist">
                      <Label>Selected Warehouse</Label>
                      <Multiselect
                        showCheckbox
                        isObject
                        options={WareHouseList}
                        selectedValues={SelectedWareHouse}
                        displayValue="warehouseName"
                        onSelect={(list) => setSelectedWareHouse(list)}
                        onRemove={(list) => setSelectedWareHouse(list)}
                      />

                      {String(Params?.id) !== "0" && (
                        <div
                          className="mt-2"
                          style={{
                            border: "1px solid #e5e7eb",
                            borderRadius: 8,
                            padding: "8px 10px",
                            background: "#f8fafc",
                          }}
                        >
                          <div style={{ fontWeight: 700, marginBottom: 5 }}>
                            Current Warehouses
                          </div>
                          {visibleWarehouses.length ? (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 5,
                              }}
                            >
                              {visibleWarehouses.map(
                                (warehouse, warehouseIndex) => (
                                  <Badge
                                    key={`${warehouse?._id || warehouseIndex}`}
                                    color="secondary"
                                  >
                                    {warehouse?.warehouseName ||
                                      warehouse?.name ||
                                      warehouse?._id ||
                                      "Warehouse"}
                                  </Badge>
                                ),
                              )}
                            </div>
                          ) : (
                            <span style={{ color: "#64748b", fontSize: 12 }}>
                              No warehouse assigned
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </Col>
                )}

                {/* Master extra fields */}
                {Master && (
                  <>
                    <Col className="mb-1" lg="6" md="6" sm="12">
                      <Label>Select Roles to Assign *</Label>
                      <Multiselect
                        showCheckbox
                        isObject
                        options={AllAssignRoleList}
                        selectedValues={SelectedRoleToAssign}
                        displayValue="roleName"
                        onSelect={onSelect1}
                        onRemove={onRemove1}
                      />
                    </Col>
                    {Mode !== "Update" && (
                      <Col lg="6" md="6" sm="12">
                        <FormGroup className="cssforproductlist">
                          <Label>
                            Plan Name <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            required
                            type="select"
                            value={formData?.subscriptionPlan || ""}
                            onChange={(e) =>
                              setFormData((p) => ({
                                ...p,
                                subscriptionPlan: e.target.value,
                              }))
                            }
                          >
                            <option value="">----select Plan----</option>
                            {(SubsCriptionList || []).map((s) => (
                              <option key={s?._id} value={s?._id}>
                                {s?.planName} (Price {s?.subscriptionCost}) (
                                {s?.subscriptionType === 1
                                  ? "Yearly"
                                  : "One Time"}
                                )
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    )}
                    <Col lg="6" md="6" sm="12">
                      <FormGroup className="cssforproductlist">
                        <Label>
                          Database Name <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          required
                          placeholder="your-db-name"
                          value={formData?.database || ""}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              database: e.target.value,
                            }))
                          }
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}

                {!Master && (
                  <>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup className="cssforproductlist">
                        <Label>Appointment Date</Label>
                        <Input
                          type="date"
                          name="last_job_AppoitmentDate"
                          value={formData?.last_job_AppoitmentDate || ""}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              last_job_AppoitmentDate: e.target.value,
                            }))
                          }
                        />
                      </FormGroup>
                    </Col>

                    {(formData?.position ||
                      dropdownValue.find(
                        (r) => String(r?._id) === String(formData?.rolename),
                      )?.roleName ||
                      "") === "Sales Person" && (
                      <Col lg="6" md="6" sm="12">
                        <FormGroup className="cssforproductlist">
                          <Label>Area</Label>
                          <Input
                            name="area"
                            placeholder="Enter area"
                            value={formData?.area || ""}
                            onChange={(e) =>
                              setFormData((p) => ({
                                ...p,
                                area: e.target.value,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                    )}

                    <Col lg="6" md="6" sm="12">
                      <FormGroup className="cssforproductlist">
                        <Label>Base Salary / Month</Label>
                        <Input
                          type="number"
                          name="last_job_Salary"
                          placeholder="Base salary"
                          value={formData?.last_job_Salary || ""}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              last_job_Salary: e.target.value,
                            }))
                          }
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="6" md="6" sm="12">
                      <FormGroup className="cssforproductlist">
                        <Label>PF Percentage</Label>
                        <Input
                          type="number"
                          max={99}
                          name="pfPercentage"
                          placeholder="e.g. 8"
                          value={formData?.pfPercentage || ""}
                          onChange={(e) => {
                            const v = e.target.value;
                            if (/^\d{0,2}$/.test(v)) {
                              setFormData((p) => ({
                                ...p,
                                pfPercentage: v,
                              }));
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>

                    {currentRoleName !== "SuperAdmin" && (
                      <>
                        <Col lg="6" md="6" sm="12">
                          <FormGroup className="cssforproductlist">
                            <Label>Opening Financial Year</Label>
                            <Input
                              type="select"
                              name="openingFinancialYear"
                              value={
                                formData?.openingFinancialYear ||
                                getCurrentOpeningFinancialYear()
                              }
                              onChange={(e) =>
                                setFormData((p) => ({
                                  ...p,
                                  openingFinancialYear:
                                    normalizeOpeningFinancialYear(
                                      e.target.value,
                                    ),
                                }))
                              }
                            >
                              {openingFYOptions.map((fy) => (
                                <option key={fy} value={fy}>
                                  {fy}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                          <FormGroup className="cssforproductlist">
                            <Label>Opening Balance</Label>
                            <Input
                              type="number"
                              name="OpeningBalance"
                              value={formData?.OpeningBalance || ""}
                              onChange={(e) =>
                                setFormData((p) => ({
                                  ...p,
                                  OpeningBalance: e.target.value,
                                }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                          <FormGroup className="cssforproductlist">
                            <Label>O/P Balance Type</Label>
                            <Input
                              type="select"
                              name="Type"
                              value={formData?.Type || ""}
                              onChange={(e) =>
                                setFormData((p) => ({
                                  ...p,
                                  Type: e.target.value,
                                }))
                              }
                            >
                              <option value="">----select Type----</option>
                              <option value="debit">Dr</option>
                              <option value="credit">Cr</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </>
                    )}
                  </>
                )}
              </Row>
            </CardBody>
          )}
        </Col>
      </Row>

      {/* Role & product pricing block */}
      {showRolePricing && (
        <>
          <CardBody className="userRegiBody">
            <div className="d-flex justify-content-center">
              <h1>Add Role and Update Product Prices</h1>
            </div>
            {Array.from({ length: rowCount }).map((_, outerIndex) => (
              <Col
                lg="12"
                key={`role-row-${outerIndex}`}
                style={{ marginTop: 10 }}
              >
                <Row className="px-2">
                  {/* Process */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: 160,
                      marginBottom: 10,
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        marginBottom: 5,
                      }}
                    >
                      Select Process
                    </span>
                    <select
                      style={{
                        fontSize: 12,
                        minHeight: 30,
                        padding: 5,
                        border: "1px solid #ccc",
                        borderRadius: 4,
                      }}
                      value={formData?.role?.[outerIndex]?.process || ""}
                      onChange={(e) => {
                        const processVal = e.target.value;
                        const filterSteps =
                          (list || []).find((p) => p.name === processVal)
                            ?.steps || [];
                        setFormData((prev) => {
                          const role = (prev.role || []).slice();
                          role[outerIndex] = {
                            ...(role[outerIndex] || {}),
                            process: processVal,
                            processSteps: filterSteps,
                          };
                          return { ...prev, role };
                        });
                      }}
                    >
                      <option value="">Select Process</option>
                      {(list || []).map((p) => (
                        <option key={p?.name} value={p?.name}>
                          {p?.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Role (step) */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: 180,
                      marginLeft: 10,
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        marginBottom: 5,
                      }}
                    >
                      Select Role
                    </span>
                    <select
                      style={{
                        fontSize: 12,
                        minHeight: 30,
                        padding: 5,
                        border: "1px solid #ccc",
                        borderRadius: 4,
                      }}
                      value={formData?.role?.[outerIndex]?.roleName || ""}
                      onChange={(e) => {
                        const roleName = e.target.value;
                        const steps =
                          formData?.role?.[outerIndex]?.processSteps || [];
                        const findIndex = steps.findIndex(
                          (s) => s.step_Name === roleName,
                        );
                        const filterProducts = (productName || [])
                          .filter((prod) => {
                            const sub = prod?.SubStep || "";
                            const next = prod?.NextSubStep || "";
                            if (findIndex === 0) return sub === roleName;
                            return sub === roleName || next === roleName;
                          })
                          .map((prod) => ({
                            Product_Title: prod?.Product_Title,
                            stockUnit: prod?.stockUnit,
                          }));

                        setFormData((prev) => {
                          const role = (prev.role || []).slice();
                          role[outerIndex] = {
                            ...(role[outerIndex] || {}),
                            roleName,
                            roleProducts: filterProducts,
                          };
                          return { ...prev, role };
                        });
                      }}
                    >
                      <option value="">Select Role</option>
                      {(formData?.role?.[outerIndex]?.processSteps || []).map(
                        (s, i) => (
                          <option
                            key={`${s?.step_Name}-${i}`}
                            value={s?.step_Name}
                          >
                            {s?.step_Name}
                          </option>
                        ),
                      )}
                    </select>
                  </div>

                  {/* products */}
                  <div style={{ width: "100%", marginTop: 10 }}>
                    {(formData?.role?.[outerIndex]?.productAndPrice || []).map(
                      (p, productIndex) => (
                        <div
                          key={`prod-${productIndex}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            margin: "10px 0",
                            padding: 10,
                            borderRadius: 8,
                            background: "#fff",
                            boxShadow:
                              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                          }}
                        >
                          {/* Product */}
                          <div style={{ width: 220 }}>
                            <span style={{ fontSize: 13, fontWeight: 500 }}>
                              Product
                            </span>
                            <select
                              style={{
                                fontSize: 12,
                                minHeight: 30,
                                width: 220,
                                border: "none",
                                borderRadius: 5,
                                backgroundColor: "#ECF2FE",
                                boxShadow:
                                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                              }}
                              value={p?.productName || ""}
                              onChange={(e) =>
                                handleProductChange(
                                  outerIndex,
                                  productIndex,
                                  "productName",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">Select Product</option>
                              {(
                                formData?.role?.[outerIndex]?.roleProducts || []
                              ).map((rp, i) => (
                                <option
                                  key={`${rp?.Product_Title}-${i}`}
                                  value={rp?.Product_Title}
                                >
                                  {rp?.Product_Title}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Unit */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginLeft: 10,
                            }}
                          >
                            <span style={{ fontSize: 13, fontWeight: 500 }}>
                              Unit
                            </span>
                            <span
                              style={{
                                fontSize: 12,
                                minHeight: 30,
                                width: 60,
                                borderRadius: 5,
                                backgroundColor: "#ECF2FE",
                                boxShadow:
                                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {(productName || []).find(
                                (x) => x.Product_Title === p?.productName,
                              )?.stockUnit || ""}
                            </span>
                          </div>

                          {/* Price */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginLeft: 10,
                            }}
                          >
                            <span style={{ fontSize: 13, fontWeight: 500 }}>
                              Price
                            </span>
                            <input
                              type="number"
                              value={p?.price || ""}
                              onChange={(e) =>
                                handleProductChange(
                                  outerIndex,
                                  productIndex,
                                  "price",
                                  e.target.value,
                                )
                              }
                              style={{
                                fontSize: 12,
                                minHeight: 30,
                                width: 80,
                                border: "none",
                                backgroundColor: "#ECF2FE",
                                borderRadius: 5,
                                boxShadow:
                                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                                paddingLeft: 8,
                              }}
                            />
                          </div>

                          {/* remove product */}
                          <Button
                            color="link"
                            onClick={() =>
                              removeAddedProducts(outerIndex, productIndex)
                            }
                            style={{
                              marginTop: 18,
                              marginLeft: 10,
                              textDecoration: "none",
                            }}
                          >
                            ❌
                          </Button>
                        </div>
                      ),
                    )}

                    <Button
                      type="button"
                      style={{
                        backgroundColor: "#085BF5",
                        color: "white",
                      }}
                      onClick={() => handleAddProduct(outerIndex)}
                    >
                      Add Product
                    </Button>
                  </div>

                  {/* remove role row */}
                  <div className="d-flex justify-content-end w-100 mt-2">
                    <Button
                      color="link"
                      onClick={() => handleRemoveRole(outerIndex)}
                    >
                      Remove Role Row
                    </Button>
                  </div>
                </Row>
              </Col>
            ))}
          </CardBody>

          <div className="d-flex justify-content-end">
            <Button
              type="button"
              style={{ backgroundColor: "#085BF5", color: "white" }}
              onClick={handleAddMoreRows}
            >
              Add more role
            </Button>
          </div>
        </>
      )}

      {/* Status + Submit */}
      <Row className="mt-3">
        <Col lg="6" md="6" sm="12" className="mb-2">
          <Label className="mb-0">Status</Label>
          <div className="d-flex align-items-center gap-3">
            <label className="m-0 d-flex align-items-center gap-1">
              <Input
                type="radio"
                name="status"
                checked={formData?.status === "Active"}
                onChange={() =>
                  setFormData((p) => ({ ...p, status: "Active" }))
                }
              />
              <span>Active</span>
            </label>
            <label className="m-0 d-flex align-items-center gap-1">
              <Input
                type="radio"
                name="status"
                checked={formData?.status === "Deactive"}
                onChange={() =>
                  setFormData((p) => ({ ...p, status: "Deactive" }))
                }
              />
              <span>Deactive</span>
            </label>
          </div>
        </Col>
      </Row>

      {Loader ? (
        <Row>
          <Col className="d-flex justify-content-center">
            <Spinner>Loading...</Spinner>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col className="d-flex justify-content-center">
            <Button color="primary" type="submit" className="mt-2">
              {BulkUpload ? "Save This User" : Mode}
            </Button>
          </Col>
        </Row>
      )}
    </>
  );

  const renderBulkUploadContent = () => (
    <>
      <CardBody className="userRegiBody">
        <div className="d-flex justify-content-center">
          <h1>Bulk Upload Users</h1>
        </div>

        <Row>
          <Col className="d-flex justify-content-center">
            <div className="parent" style={{ width: "100%" }}>
              <div className="file-upload mb-3">
                <p className="mb-1" style={{ fontWeight: 700 }}>
                  Select the User List Excel file
                </p>
                <p className="mb-2" style={{ fontSize: 12, opacity: 0.7 }}>
                  One row fills the normal form. Multiple rows are shown as
                  expandable user cards.
                </p>
                <input
                  type="file"
                  name="file"
                  accept=".csv,.xls,.xlsx"
                  onChange={handleBulkFileChange}
                  disabled={Loading || bulkSaveAllLoading}
                />
              </div>
            </div>
          </Col>
        </Row>

        {BulkImport && (
          <Row className="mb-2">
            <Col className="d-flex justify-content-center">
              <Badge color="success">Selected: {BulkImport.name}</Badge>
            </Col>
          </Row>
        )}

        {Loading && !bulkUsers.length && (
          <Row>
            <Col className="d-flex justify-content-center">
              <Spinner>Reading...</Spinner>
            </Col>
          </Row>
        )}

        {bulkUsers.length > 0 && (
          <>
            <Row className="mt-2 mb-2">
              <Col className="d-flex justify-content-between align-items-center">
                <strong>Unsaved Users: {bulkUsers.length}</strong>
                <Button
                  type="button"
                  color="primary"
                  onClick={handleSaveAllBulkUsers}
                  disabled={bulkSaveAllLoading || Loading}
                >
                  {bulkSaveAllLoading ? "Saving All..." : "Save All"}
                </Button>
              </Col>
            </Row>

            <div className="mt-2">
              {bulkUsers.map((item, itemIndex) => {
                const data = item?.data || {};
                const isOpen = expandedBulkIndex === itemIndex;

                return (
                  <div className="cu-bulk-card" key={item?.tempId || itemIndex}>
                    <div
                      className="cu-bulk-head"
                      onClick={() => openBulkUser(itemIndex)}
                    >
                      <div>
                        <div className="cu-bulk-title">
                          {data?.firstName || `User Row ${itemIndex + 1}`} -{" "}
                          {data?.email || data?.mobileNumber || data?.id || "-"}
                        </div>
                        {item?.errorMessage && (
                          <div className="cu-bulk-error">
                            {item.errorMessage}
                          </div>
                        )}
                      </div>

                      <button
                        type="button"
                        className="cu-bulk-cross"
                        onClick={(event) => removeBulkUser(itemIndex, event)}
                      >
                        ×
                      </button>
                    </div>

                    {isOpen && (
                      <div className="cu-bulk-body">
                        {renderUserFormFields()}
                        {bulkSavingIndex === itemIndex && (
                          <div className="text-center mt-2">
                            <Spinner size="sm" />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </CardBody>
    </>
  );

  return (
    <div className="cu">
      <Card className="UserRegistrationform" style={{ padding: 15 }}>
        {/* Header actions */}
        <Row className="align-items-center mb-1">
          <Col />
          <Col className="text-center mt-1">
            <h1 className="m-0">
              {Mode} {Master ? "SuperAdmin" : "User"}
            </h1>
          </Col>
          <Col
            className="d-flex justify-content-end gap-1 mt-1"
            lg="4"
            md="5"
            sm="12"
          >
            {!BulkUpload ? (
              <>
                {String(Params?.id) === "0" && (
                  <Button
                    type="button"
                    style={{ backgroundColor: "rgb(8, 91, 245)" }}
                    onClick={() => setBulkUpload(true)}
                  >
                    Bulk Upload
                  </Button>
                )}

                <Button color="secondary" onClick={goBack}>
                  Back
                </Button>
              </>
            ) : (
              <>
                <Button
                  type="button"
                  style={{ backgroundColor: "rgb(8, 91, 245)" }}
                  onClick={exitBulkUploadMode}
                >
                  Back
                </Button>
              </>
            )}
            {Mode === "Update" ? (
              <>
                <Button
                  style={{ backgroundColor: "rgb(8, 91, 245)" }}
                  onClick={() => handleDelete(Params?.id)}
                >
                  Delete
                </Button>
              </>
            ) : (
              console.log("Not editing the page!")
            )}
          </Col>
        </Row>

        <Form onSubmit={submitHandler}>
          {/* ===== Bulk Upload ===== */}
          {BulkUpload ? renderBulkUploadContent() : renderUserFormFields()}
        </Form>
      </Card>

      {/* ===== Address selection modal (Sales Person / Sales Manager) ===== */}
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Select Address</ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2 flex-wrap">
              <Input
                type="text"
                name="state"
                value={filters.state}
                placeholder="Filter by State"
                onChange={handleFilterChange}
              />
              <Input
                type="text"
                name="district"
                value={filters.district}
                placeholder="Filter by District"
                onChange={handleFilterChange}
              />
            </div>
            <Button color="primary" onClick={handleSelectFiltered}>
              Select All Filtered
            </Button>
            <Button
              color="secondary"
              disabled={pinLoading || page >= totalPages}
              onClick={() => fetchPincodeData(page + 1, limit, pinSearch)}
            >
              Next
            </Button>
          </div>

          {pinLoading && (
            <div className="d-flex align-items-center gap-2 mb-2">
              <Spinner size="sm" />
              <span style={{ fontSize: 12, fontWeight: 600 }}>Loading...</span>
            </div>
          )}

          <Table bordered responsive hover className="align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-center" style={{ width: 80 }}>
                  Select
                </th>
                <th>State</th>
                <th>District</th>
                <th>City</th>
                <th>Pincode</th>
              </tr>
            </thead>
            <tbody>
              {filteredList.map((item, index) => (
                <tr key={`${item?.pincode}-${index}`}>
                  <td className="text-center">
                    <Input
                      type="checkbox"
                      className="form-check-input m-0"
                      style={{ transform: "scale(1.2)" }}
                      checked={isChecked(item)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                  </td>
                  <td>{item.state}</td>
                  <td>{item.district}</td>
                  <td>{item.city}</td>
                  <td>{item.pincode}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <Button
              color="secondary"
              disabled={pinLoading || page <= 1}
              onClick={() => fetchPincodeData(page - 1, limit, pinSearch)}
            >
              Prev
            </Button>

            <div style={{ fontSize: 12, fontWeight: 600 }}>
              Page {page} / {totalPages}
            </div>

            <Button
              color="secondary"
              disabled={pinLoading || page >= totalPages}
              onClick={() => fetchPincodeData(page + 1, limit, pinSearch)}
            >
              Next
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CreateAccount;
